var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG704(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136.86pt",
    height: "44.412pt",
    viewBox: "0 0 136.86 44.412",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3438 0h-2.2656v-0.35938l1.4688-1.8281s0.03125-0.039062 0.09375-0.125c0.070313-0.082031 0.14062-0.15625 0.20312-0.21875h-1.6094v-0.32812h2.0469v0.32812l-1.5938 1.9844-0.17188 0.20312h1.8281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6719 0h-0.42188l-0.34375-0.875h-1.1875l-0.32812 0.875h-0.39062l1.0938-2.8594h0.40625zm-0.875-1.1719c-0.24219-0.625-0.375-0.97656-0.40625-1.0625-0.023437-0.082031-0.054687-0.19141-0.09375-0.32812h-0.015625c-0.03125 0.1875-0.078125 0.36719-0.14062 0.53125l-0.3125 0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8438 0h-0.46875c-0.29297-0.44531-0.47656-0.72266-0.54688-0.82812-0.0625-0.10156-0.13672-0.19141-0.21875-0.26562-0.074219-0.070312-0.14844-0.11719-0.21875-0.14062-0.0625-0.019531-0.14844-0.03125-0.25-0.03125h-0.4375v1.2656h-0.375v-2.8594h1.2656c0.16406 0 0.30469 0.011719 0.42188 0.03125 0.125 0.023437 0.22656 0.070313 0.3125 0.14062 0.09375 0.074219 0.16016 0.16406 0.20312 0.26562 0.050781 0.10547 0.078125 0.21875 0.078125 0.34375 0 0.21875-0.070313 0.39844-0.20312 0.53125-0.13672 0.125-0.33594 0.20312-0.59375 0.23438v0.015625c0.1875 0.085937 0.36328 0.25781 0.53125 0.51562zm-2.1406-1.6094h0.8125c0.16406 0 0.29688-0.00781 0.39062-0.03125 0.09375-0.03125 0.16406-0.085937 0.21875-0.17188 0.0625-0.082031 0.09375-0.17188 0.09375-0.26562 0-0.13281-0.046875-0.24219-0.14062-0.32812-0.09375-0.09375-0.25-0.14062-0.46875-0.14062h-0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625 0h-0.375v-1.3438h-1.4844v1.3438h-0.375v-2.8594h0.375v1.1719h1.4844v-1.1719h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625-2.9062c0.39453 0 0.71875 0.13672 0.96875 0.40625 0.25781 0.27344 0.39062 0.63281 0.39062 1.0781 0 0.4375-0.13281 0.79297-0.39062 1.0625-0.25 0.27344-0.57422 0.40625-0.96875 0.40625-0.41797 0-0.75-0.14062-1-0.42188s-0.375-0.61719-0.375-1.0156c0-0.47656 0.125-0.84766 0.375-1.1094 0.25781-0.26953 0.59375-0.40625 1-0.40625zm0 2.625c0.28906 0 0.52344-0.097656 0.70312-0.29688 0.17578-0.20703 0.26562-0.48828 0.26562-0.84375 0-0.375-0.09375-0.66016-0.28125-0.85938-0.17969-0.20703-0.40625-0.3125-0.6875-0.3125s-0.51562 0.10156-0.70312 0.29688c-0.1875 0.19922-0.28125 0.5-0.28125 0.90625 0 0.33594 0.085937 0.60547 0.26562 0.8125 0.1875 0.19922 0.42578 0.29688 0.71875 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0312 0h-0.35938v-2.3906h-0.015625l-0.8125 2.3906h-0.34375l-0.82812-2.4375v2.4375h-0.35938v-2.8594h0.5625l0.67188 2.0156c0.070313 0.23047 0.11719 0.375 0.14062 0.4375 0.03125-0.11328 0.082031-0.26953 0.15625-0.46875l0.6875-1.9844h0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4531 0h-2.1406v-2.8594h2.0781v0.32812h-1.6875v0.875h1.5781v0.34375h-1.5781v0.96875h1.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156-2.0312c-0.023437-0.17578-0.089844-0.3125-0.20312-0.40625-0.11719-0.09375-0.28125-0.14062-0.5-0.14062-0.19922 0-0.35938 0.039063-0.48438 0.10938-0.11719 0.074219-0.17188 0.18359-0.17188 0.32812 0 0.125 0.046875 0.21875 0.14062 0.28125 0.09375 0.054687 0.27344 0.10938 0.54688 0.17188 0.22656 0.054688 0.41406 0.10547 0.5625 0.15625 0.15625 0.054688 0.28516 0.14062 0.39062 0.26562 0.11328 0.11719 0.17188 0.26562 0.17188 0.45312 0 0.25-0.10156 0.46094-0.29688 0.625-0.19922 0.15625-0.45312 0.23438-0.76562 0.23438-0.40625 0-0.71094-0.085938-0.90625-0.26562-0.19922-0.17578-0.30469-0.41016-0.3125-0.70312l0.35938-0.03125c0.007813 0.23047 0.09375 0.39844 0.25 0.5 0.16406 0.10547 0.36328 0.15625 0.59375 0.15625 0.20703 0 0.375-0.039063 0.5-0.125 0.13281-0.09375 0.20312-0.21094 0.20312-0.35938 0-0.15625-0.070312-0.26953-0.20312-0.34375-0.13672-0.070312-0.36719-0.14062-0.6875-0.20312-0.32422-0.070313-0.55859-0.17188-0.70312-0.29688-0.13672-0.125-0.20312-0.28906-0.20312-0.5 0-0.22656 0.085937-0.41406 0.26562-0.5625 0.17578-0.14453 0.42188-0.21875 0.73438-0.21875 0.32031 0 0.57812 0.074219 0.76562 0.21875 0.19531 0.14844 0.30078 0.35938 0.3125 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.3125-2.8594h1.0781c0.16406 0 0.3125 0.011719 0.4375 0.03125 0.125 0.011719 0.23828 0.054687 0.34375 0.125 0.10156 0.074219 0.17969 0.17188 0.23438 0.29688 0.0625 0.11719 0.09375 0.24219 0.09375 0.375 0 0.26172-0.089844 0.47656-0.26562 0.64062-0.16797 0.15625-0.4375 0.23438-0.8125 0.23438h-0.73438v1.1562h-0.375zm0.375 1.3594h0.73438c0.44531 0 0.67188-0.17578 0.67188-0.53125 0-0.11328-0.03125-0.21094-0.09375-0.29688-0.054688-0.082031-0.12109-0.13281-0.20312-0.15625-0.085937-0.03125-0.21094-0.046875-0.375-0.046875h-0.73438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625 0h-0.375l-1.5-2.25h-0.015625v2.25h-0.35938v-2.8594h0.39062l1.5 2.25v-2.25h0.35938zm-0.40625-3.5312c0 0.14844-0.042969 0.25781-0.125 0.32812-0.074219 0.074219-0.16406 0.10938-0.26562 0.10938-0.0625 0-0.11719-0.00391-0.15625-0.015625-0.042969-0.019531-0.089844-0.046875-0.14062-0.078125-0.09375-0.0625-0.16797-0.09375-0.21875-0.09375-0.10547 0-0.16406 0.0625-0.17188 0.1875h-0.23438c0-0.14453 0.035156-0.25391 0.10938-0.32812 0.082031-0.070313 0.17578-0.10938 0.28125-0.10938 0.082031 0 0.17188 0.03125 0.26562 0.09375 0.10156 0.054688 0.1875 0.078125 0.25 0.078125 0.09375 0 0.14453-0.054687 0.15625-0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562 0c0 0.16406-0.03125 0.28906-0.09375 0.375-0.0625 0.09375-0.14062 0.15625-0.23438 0.1875l-0.09375-0.14062c0.14453-0.0625 0.21875-0.20312 0.21875-0.42188h-0.20312v-0.40625h0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.75 0h-0.39062v-0.40625h0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6406-2.8594-1.125 2.8594h-0.375l-1.1094-2.8594h0.40625l0.73438 2.0781c0.0625 0.13672 0.11328 0.29297 0.15625 0.46875 0.039063-0.15625 0.09375-0.3125 0.15625-0.46875l0.76562-2.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.32812-2.8594h0.98438c0.16406 0 0.3125 0.011719 0.4375 0.03125 0.125 0.011719 0.24219 0.054687 0.35938 0.125 0.11328 0.0625 0.21094 0.15625 0.29688 0.28125 0.09375 0.11719 0.16016 0.25 0.20312 0.40625 0.050781 0.15625 0.078125 0.34375 0.078125 0.5625 0 0.42969-0.10156 0.77734-0.29688 1.0469-0.19922 0.27344-0.54297 0.40625-1.0312 0.40625h-1.0312zm0.375 2.5156h0.60938c0.125 0 0.23438-0.003906 0.32812-0.015625 0.10156-0.019531 0.20312-0.0625 0.29688-0.125 0.10156-0.070313 0.1875-0.1875 0.25-0.34375 0.070312-0.15625 0.10938-0.36328 0.10938-0.625 0-0.14453-0.015625-0.28125-0.046875-0.40625-0.023438-0.125-0.070312-0.23438-0.14062-0.32812-0.0625-0.10156-0.14062-0.17969-0.23438-0.23438-0.085938-0.050781-0.16797-0.082031-0.25-0.09375-0.085938-0.007813-0.19531-0.015625-0.32812-0.015625h-0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.75 0h-0.375v-2.8594h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625-1.2031c0 0.14844-0.011719 0.28125-0.03125 0.40625-0.011719 0.125-0.054688 0.25781-0.125 0.39062-0.0625 0.125-0.17188 0.23438-0.32812 0.32812-0.15625 0.082031-0.36719 0.125-0.625 0.125-0.26172 0-0.46875-0.039062-0.625-0.10938-0.15625-0.082031-0.27344-0.1875-0.34375-0.3125-0.074219-0.125-0.12109-0.25-0.14062-0.375-0.023438-0.13281-0.03125-0.28516-0.03125-0.45312v-1.6562h0.39062v1.6406c0 0.17969 0.007813 0.32812 0.03125 0.45312 0.019531 0.125 0.082031 0.23438 0.1875 0.32812 0.11328 0.09375 0.28125 0.14062 0.5 0.14062s0.38281-0.035156 0.5-0.10938c0.11328-0.082031 0.1875-0.1875 0.21875-0.3125s0.046875-0.28906 0.046875-0.5v-1.6406h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3594-2.5312h-0.95312v2.5312h-0.375v-2.5312h-0.9375v-0.32812h2.2656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7344-0.90625c-0.085937 0.32422-0.23047 0.5625-0.4375 0.71875-0.21094 0.15625-0.46094 0.23438-0.75 0.23438-0.46875 0-0.8125-0.14453-1.0312-0.4375-0.21094-0.28906-0.3125-0.64453-0.3125-1.0625 0-0.45703 0.125-0.8125 0.375-1.0625 0.25-0.25781 0.57031-0.39062 0.96875-0.39062 0.28125 0 0.51953 0.074219 0.71875 0.21875 0.19531 0.13672 0.33594 0.33984 0.42188 0.60938l-0.375 0.09375c-0.0625-0.19531-0.15625-0.34766-0.28125-0.45312-0.125-0.10156-0.28906-0.15625-0.48438-0.15625-0.3125 0-0.55469 0.10547-0.71875 0.3125-0.15625 0.21094-0.23438 0.48438-0.23438 0.82812 0 0.39844 0.082031 0.69531 0.25 0.89062 0.17578 0.1875 0.39844 0.28125 0.67188 0.28125 0.22656 0 0.41016-0.054688 0.54688-0.17188 0.13281-0.125 0.23438-0.30469 0.29688-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625-2.9062c0.39453 0 0.71875 0.13672 0.96875 0.40625 0.25781 0.27344 0.39062 0.63281 0.39062 1.0781 0 0.4375-0.13281 0.79297-0.39062 1.0625-0.25 0.27344-0.57422 0.40625-0.96875 0.40625-0.41797 0-0.75-0.14062-1-0.42188s-0.375-0.61719-0.375-1.0156c0-0.47656 0.125-0.84766 0.375-1.1094 0.25781-0.26953 0.59375-0.40625 1-0.40625zm0 2.625c0.28906 0 0.52344-0.097656 0.70312-0.29688 0.17578-0.20703 0.26562-0.48828 0.26562-0.84375 0-0.375-0.09375-0.66016-0.28125-0.85938-0.17969-0.20703-0.40625-0.3125-0.6875-0.3125s-0.51562 0.10156-0.70312 0.29688c-0.1875 0.19922-0.28125 0.5-0.28125 0.90625 0 0.33594 0.085937 0.60547 0.26562 0.8125 0.1875 0.19922 0.42578 0.29688 0.71875 0.29688zm0.5-3.3125-0.4375 0.54688h-0.29688l0.26562-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625 0h-0.375l-1.5-2.25h-0.015625v2.25h-0.35938v-2.8594h0.39062l1.5 2.25v-2.25h0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6406 0h-0.46875l-0.5625-0.8125c-0.14844-0.19531-0.23438-0.33203-0.26562-0.40625h-0.015625c0 0.03125-0.28125 0.4375-0.84375 1.2188h-0.46875l1.1094-1.5-0.96875-1.3594h0.4375l0.60938 0.84375c0.0625 0.09375 0.10938 0.17188 0.14062 0.23438 0.050781-0.082031 0.32031-0.44141 0.8125-1.0781h0.40625l-1 1.3438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.25-2.5312h-1.5469v0.89062h1.3438v0.34375h-1.3438v1.2969h-0.375v-2.8594h1.9219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2031-0.85938h-1.0781v-0.35938h1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 0h-0.34375v-2.2344c-0.17969 0.16797-0.41797 0.30859-0.71875 0.42188v-0.34375c0.40625-0.19531 0.67969-0.4375 0.82812-0.71875h0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.64062-1.7188c0.16406-0.125 0.34375-0.1875 0.53125-0.1875 0.23828 0 0.44531 0.089844 0.625 0.26562 0.17578 0.16797 0.26562 0.39062 0.26562 0.67188s-0.089844 0.52344-0.26562 0.71875c-0.17969 0.19922-0.41406 0.29688-0.70312 0.29688-0.24219 0-0.44922-0.066406-0.625-0.20312-0.17969-0.13281-0.27734-0.33203-0.29688-0.59375l0.35938-0.03125c0.03125 0.17969 0.09375 0.3125 0.1875 0.40625 0.10156 0.09375 0.22656 0.14062 0.375 0.14062 0.17578 0 0.31641-0.066406 0.42188-0.20312 0.11328-0.13281 0.17188-0.30078 0.17188-0.5 0-0.19531-0.058594-0.35156-0.17188-0.46875-0.11719-0.125-0.26172-0.1875-0.4375-0.1875-0.21875 0-0.39062 0.09375-0.51562 0.28125l-0.32812-0.046875 0.28125-1.4688h1.4062v0.34375h-1.1406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156-1.5469c0.17578 0.03125 0.30469 0.11719 0.39062 0.25 0.09375 0.13672 0.14062 0.28906 0.14062 0.45312 0 0.26172-0.09375 0.47656-0.28125 0.64062-0.1875 0.16797-0.41406 0.25-0.67188 0.25-0.26172 0-0.47656-0.070312-0.64062-0.21875-0.15625-0.14453-0.25-0.33594-0.28125-0.57812l0.35938-0.0625c0.03125 0.19922 0.09375 0.34375 0.1875 0.4375s0.21875 0.14062 0.375 0.14062 0.28906-0.054687 0.40625-0.17188c0.11328-0.125 0.17188-0.26953 0.17188-0.4375 0-0.15625-0.054687-0.28516-0.15625-0.39062-0.10547-0.10156-0.24219-0.15625-0.40625-0.15625-0.0625 0-0.14062 0.011719-0.23438 0.03125l0.03125-0.3125h0.21875c0.0625-0.00781 0.125-0.03125 0.1875-0.0625 0.070312-0.039063 0.12891-0.09375 0.17188-0.15625 0.039063-0.070313 0.0625-0.15625 0.0625-0.25 0-0.14453-0.046875-0.25391-0.14062-0.32812-0.09375-0.082031-0.20312-0.125-0.32812-0.125-0.13672 0-0.25 0.046875-0.34375 0.14062s-0.15234 0.22656-0.17188 0.39062l-0.34375-0.078125c0.039062-0.23828 0.14062-0.42188 0.29688-0.54688s0.34375-0.1875 0.5625-0.1875c0.23828 0 0.4375 0.074219 0.59375 0.21875 0.15625 0.13672 0.23438 0.30859 0.23438 0.51562 0 0.27344-0.13281 0.46484-0.39062 0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-0.6875h-0.39062v0.6875h-0.35938v-0.6875h-1.2344v-0.32812l1.2969-1.8438h0.29688v1.8438h0.39062zm-0.75-0.32812v-1.2812l-0.89062 1.2812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1094-2.875c0.625 0 0.9375 0.49219 0.9375 1.4688 0 0.49219-0.085937 0.85547-0.25 1.0938-0.15625 0.24219-0.38672 0.35938-0.6875 0.35938-0.61719 0-0.92188-0.48438-0.92188-1.4531 0-0.5 0.078125-0.86719 0.23438-1.1094 0.15625-0.23828 0.38281-0.35938 0.6875-0.35938zm0 2.6406c0.1875 0 0.32812-0.09375 0.42188-0.28125 0.10156-0.1875 0.15625-0.48438 0.15625-0.89062 0-0.28906-0.023438-0.51953-0.0625-0.6875-0.042969-0.16406-0.10938-0.28906-0.20312-0.375-0.085937-0.082031-0.1875-0.125-0.3125-0.125-0.1875 0-0.32812 0.09375-0.42188 0.28125s-0.14062 0.49219-0.14062 0.90625c0 0.28125 0.019531 0.50781 0.0625 0.67188 0.039063 0.16797 0.10156 0.29297 0.1875 0.375 0.082031 0.085937 0.1875 0.125 0.3125 0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.53125-1.4844c0.15625-0.25 0.38281-0.375 0.6875-0.375 0.22656 0 0.42578 0.089844 0.59375 0.26562 0.16406 0.16797 0.25 0.38672 0.25 0.65625 0 0.27344-0.085938 0.50781-0.25 0.70312-0.16797 0.1875-0.38672 0.28125-0.65625 0.28125-0.27344 0-0.50781-0.097656-0.70312-0.29688-0.1875-0.20703-0.28125-0.57031-0.28125-1.0938 0-0.50781 0.082031-0.89062 0.25-1.1406 0.17578-0.25781 0.42969-0.39062 0.76562-0.39062 0.21875 0 0.39844 0.0625 0.54688 0.1875 0.14453 0.11719 0.23828 0.28906 0.28125 0.51562l-0.35938 0.03125c-0.0625-0.30078-0.22656-0.45312-0.48438-0.45312-0.17969 0-0.33594 0.09375-0.46875 0.28125-0.125 0.17969-0.1875 0.45312-0.1875 0.82812zm0.625 1.25c0.15625 0 0.28516-0.0625 0.39062-0.1875 0.10156-0.13281 0.15625-0.29688 0.15625-0.48438s-0.054687-0.33594-0.15625-0.45312c-0.10547-0.125-0.24219-0.1875-0.40625-0.1875-0.15625 0-0.29297 0.058594-0.40625 0.17188-0.10547 0.11719-0.15625 0.26562-0.15625 0.45312s0.050781 0.35156 0.15625 0.48438c0.11328 0.13672 0.25391 0.20312 0.42188 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938 0h-1.7969v-2.8594h0.39062v2.5156h1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8594-0.40625c-0.36719 0.30469-0.76172 0.45312-1.1875 0.45312-0.4375 0-0.79297-0.12891-1.0625-0.39062-0.27344-0.26953-0.40625-0.62891-0.40625-1.0781 0-0.26953 0.050781-0.51953 0.15625-0.75 0.11328-0.23828 0.28125-0.42188 0.5-0.54688s0.47656-0.1875 0.78125-0.1875c0.32031 0 0.58203 0.074219 0.78125 0.21875 0.19531 0.13672 0.32812 0.34375 0.39062 0.625l-0.34375 0.09375c-0.054688-0.20703-0.14844-0.36328-0.28125-0.46875-0.13672-0.10156-0.32031-0.15625-0.54688-0.15625-0.34375 0-0.60547 0.10938-0.78125 0.32812-0.17969 0.21094-0.26562 0.48438-0.26562 0.82812 0 0.25 0.039062 0.46484 0.125 0.64062 0.09375 0.16797 0.22266 0.29297 0.39062 0.375 0.16406 0.085937 0.34766 0.125 0.54688 0.125 0.30078 0 0.57812-0.097656 0.82812-0.29688v-0.53125h-0.84375v-0.34375h1.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-1.5312c0.17578 0.0625 0.3125 0.15625 0.40625 0.28125 0.09375 0.11719 0.14062 0.25781 0.14062 0.42188 0 0.15625-0.042969 0.30469-0.125 0.4375-0.085938 0.13672-0.19922 0.23438-0.34375 0.29688-0.14844 0.0625-0.35156 0.09375-0.60938 0.09375h-1.0938v-2.8594h1.0781c0.34375 0 0.58594 0.078125 0.73438 0.23438 0.14453 0.14844 0.21875 0.30859 0.21875 0.48438 0 0.125-0.039063 0.24609-0.10938 0.35938-0.0625 0.10547-0.16406 0.1875-0.29688 0.25zm-1.25-0.14062h0.625c0.125 0 0.22656-0.00391 0.3125-0.015625 0.09375-0.00781 0.17188-0.046875 0.23438-0.10938 0.070312-0.0625 0.10938-0.15625 0.10938-0.28125 0-0.13281-0.039063-0.23438-0.10938-0.29688-0.0625-0.070312-0.14062-0.11328-0.23438-0.125-0.09375-0.019531-0.21484-0.03125-0.35938-0.03125h-0.57812zm0 1.3281h0.71875c0.25 0 0.42188-0.039062 0.51562-0.125 0.10156-0.09375 0.15625-0.21094 0.15625-0.35938 0-0.15625-0.054688-0.27344-0.15625-0.35938-0.10547-0.09375-0.29297-0.14062-0.5625-0.14062h-0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156-1.5469c0.35156 0.11719 0.53125 0.35938 0.53125 0.73438 0 0.24219-0.089844 0.44531-0.26562 0.60938-0.16797 0.16797-0.39062 0.25-0.67188 0.25s-0.51172-0.082031-0.6875-0.25c-0.16797-0.16406-0.25-0.375-0.25-0.625 0-0.17578 0.046875-0.33203 0.14062-0.46875 0.10156-0.13281 0.23828-0.21875 0.40625-0.25v-0.015625c-0.29297-0.082031-0.4375-0.27344-0.4375-0.57812 0-0.20703 0.070312-0.37891 0.21875-0.51562 0.15625-0.14453 0.35938-0.21875 0.60938-0.21875s0.44531 0.074219 0.59375 0.21875c0.15625 0.14844 0.23438 0.32422 0.23438 0.53125 0 0.28125-0.14062 0.46875-0.42188 0.5625zm-0.40625-0.14062c0.13281 0 0.24219-0.039062 0.32812-0.125 0.09375-0.082031 0.14062-0.1875 0.14062-0.3125 0-0.13281-0.046875-0.24219-0.14062-0.32812-0.085938-0.09375-0.19531-0.14062-0.32812-0.14062-0.13672 0-0.25 0.046875-0.34375 0.14062-0.085937 0.085937-0.125 0.18359-0.125 0.29688 0 0.14844 0.046875 0.26172 0.14062 0.34375 0.09375 0.085938 0.20312 0.125 0.32812 0.125zm0 1.4531c0.16406 0 0.30078-0.050781 0.40625-0.15625 0.11328-0.11328 0.17188-0.25391 0.17188-0.42188 0-0.17578-0.058594-0.31641-0.17188-0.42188-0.11719-0.11328-0.25-0.17188-0.40625-0.17188-0.17969 0-0.32031 0.058594-0.42188 0.17188-0.10547 0.11719-0.15625 0.25-0.15625 0.40625 0 0.16797 0.050781 0.30859 0.15625 0.42188 0.11328 0.11719 0.25391 0.17188 0.42188 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7031-1.3438c-0.074219 0.10547-0.17188 0.19531-0.29688 0.26562-0.11719 0.074219-0.24609 0.10938-0.39062 0.10938-0.23047 0-0.42969-0.082031-0.59375-0.25-0.16797-0.17578-0.25-0.40625-0.25-0.6875s0.082031-0.50781 0.25-0.6875c0.16406-0.1875 0.38281-0.28125 0.65625-0.28125 0.25781 0 0.48438 0.10547 0.67188 0.3125 0.19531 0.21094 0.29688 0.5625 0.29688 1.0625 0 0.52344-0.089844 0.91406-0.26562 1.1719-0.17969 0.25-0.42969 0.375-0.75 0.375-0.21875 0-0.40234-0.054688-0.54688-0.17188-0.14844-0.125-0.23438-0.30469-0.26562-0.54688l0.34375-0.015625c0.050781 0.30469 0.20703 0.45312 0.46875 0.45312 0.21875 0 0.38281-0.097656 0.5-0.29688 0.11328-0.19531 0.17188-0.46875 0.17188-0.8125zm-0.59375 0.0625c0.16406 0 0.30078-0.054688 0.40625-0.17188 0.10156-0.125 0.15625-0.28125 0.15625-0.46875s-0.054687-0.34375-0.15625-0.46875c-0.10547-0.13281-0.24219-0.20312-0.40625-0.20312-0.15625 0-0.29297 0.070312-0.40625 0.20312-0.11719 0.13672-0.17188 0.30469-0.17188 0.5 0 0.17969 0.050781 0.32422 0.15625 0.4375 0.11328 0.11719 0.25391 0.17188 0.42188 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156 0h-1.8906c0-0.16406 0.054688-0.32812 0.17188-0.48438 0.11328-0.16406 0.32031-0.375 0.625-0.625 0.1875-0.15625 0.35156-0.31641 0.5-0.48438 0.15625-0.16406 0.23438-0.33203 0.23438-0.5 0-0.14453-0.054688-0.26562-0.15625-0.35938-0.10547-0.09375-0.23438-0.14062-0.39062-0.14062s-0.28906 0.054688-0.39062 0.15625c-0.10547 0.09375-0.16406 0.23438-0.17188 0.42188l-0.35938-0.03125c0.019531-0.26953 0.11328-0.47266 0.28125-0.60938 0.17578-0.14453 0.39453-0.21875 0.65625-0.21875 0.28125 0 0.5 0.078125 0.65625 0.23438s0.23438 0.34375 0.23438 0.5625c0 0.17969-0.070313 0.36719-0.20312 0.5625-0.13672 0.1875-0.39844 0.4375-0.78125 0.75-0.21094 0.16797-0.35156 0.30859-0.42188 0.42188h1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562-1.6719h-0.40625v-0.40625h0.40625zm0 1.6719h-0.40625v-0.40625h0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0781 0c-0.10547 0.019531-0.19531 0.03125-0.26562 0.03125-0.15625 0-0.27344-0.027344-0.34375-0.078125-0.0625-0.0625-0.10547-0.13281-0.125-0.21875-0.011719-0.082031-0.015625-0.19531-0.015625-0.34375v-1.1875h-0.26562v-0.28125h0.26562v-0.51562l0.34375-0.20312v0.71875h0.35938v0.28125h-0.35938v1.2031c0 0.10547 0.007813 0.18359 0.03125 0.23438 0.019531 0.042969 0.078125 0.0625 0.17188 0.0625 0.050781 0 0.10156-0.003906 0.15625-0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0625-0.95312h-1.5469c0.007813 0.23047 0.070313 0.40625 0.1875 0.53125 0.125 0.125 0.27344 0.1875 0.45312 0.1875 0.125 0 0.23438-0.035156 0.32812-0.10938 0.09375-0.070312 0.16406-0.17969 0.21875-0.32812l0.35938 0.046875c-0.0625 0.21875-0.17188 0.38672-0.32812 0.5-0.15625 0.11719-0.35156 0.17188-0.57812 0.17188-0.3125 0-0.55859-0.09375-0.73438-0.28125-0.17969-0.19531-0.26562-0.45703-0.26562-0.78125 0-0.33203 0.082031-0.59766 0.25-0.79688 0.17578-0.20703 0.41406-0.3125 0.71875-0.3125 0.15625 0 0.30078 0.039062 0.4375 0.10938 0.14453 0.0625 0.26562 0.17969 0.35938 0.34375 0.09375 0.15625 0.14062 0.39844 0.14062 0.71875zm-0.35938-0.28125c-0.011719-0.20703-0.074219-0.35938-0.1875-0.45312-0.11719-0.09375-0.24609-0.14062-0.39062-0.14062-0.16797 0-0.30469 0.058594-0.40625 0.17188-0.10547 0.10547-0.16797 0.24609-0.1875 0.42188zm-0.078125-1.6719-0.4375 0.54688h-0.29688l0.26562-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7344-2.8594-0.79688 2.8594h-0.35938l-0.625-2.25c-0.03125-0.125-0.054687-0.21094-0.0625-0.26562l-0.078125 0.32812-0.60938 2.1875h-0.39062l-0.76562-2.8594h0.39062l0.4375 1.875c0.0625 0.25 0.097656 0.43359 0.10938 0.54688 0.007813 0.023438 0.015625 0.03125 0.015625 0.03125 0.050781-0.23828 0.09375-0.41406 0.125-0.53125l0.54688-1.9219h0.45312l0.40625 1.4375c0.10156 0.36719 0.17578 0.70312 0.21875 1.0156h0.015625c0.03125-0.15625 0.078125-0.36328 0.14062-0.625l0.45312-1.8281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-2.5469c-0.28125 0.30469-0.52734 0.68359-0.73438 1.1406-0.21094 0.44922-0.32812 0.91797-0.35938 1.4062h-0.35938c0.007812-0.38281 0.10156-0.8125 0.28125-1.2812 0.1875-0.46875 0.42578-0.86719 0.71875-1.2031h-1.4062v-0.34375h1.8594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-9-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6875-0.92188c0 0.35547-0.074219 0.60547-0.21875 0.75-0.14844 0.14844-0.34375 0.21875-0.59375 0.21875s-0.44531-0.070312-0.57812-0.21875c-0.125-0.14453-0.1875-0.35938-0.1875-0.64062l0.34375-0.046875c0 0.1875 0.035156 0.32812 0.10938 0.42188 0.070312 0.09375 0.17578 0.14062 0.3125 0.14062 0.13281 0 0.23438-0.03125 0.29688-0.09375s0.097656-0.12891 0.10938-0.20312c0.00781-0.082031 0.015625-0.17969 0.015625-0.29688v-1.9688h0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7344-0.90625c-0.085937 0.32422-0.23047 0.5625-0.4375 0.71875-0.21094 0.15625-0.46094 0.23438-0.75 0.23438-0.46875 0-0.8125-0.14453-1.0312-0.4375-0.21094-0.28906-0.3125-0.64453-0.3125-1.0625 0-0.45703 0.125-0.8125 0.375-1.0625 0.25-0.25781 0.57031-0.39062 0.96875-0.39062 0.28125 0 0.51953 0.074219 0.71875 0.21875 0.19531 0.13672 0.33594 0.33984 0.42188 0.60938l-0.375 0.09375c-0.0625-0.19531-0.15625-0.34766-0.28125-0.45312-0.125-0.10156-0.28906-0.15625-0.48438-0.15625-0.3125 0-0.55469 0.10547-0.71875 0.3125-0.15625 0.21094-0.23438 0.48438-0.23438 0.82812 0 0.39844 0.082031 0.69531 0.25 0.89062 0.17578 0.1875 0.39844 0.28125 0.67188 0.28125 0.22656 0 0.41016-0.054688 0.54688-0.17188 0.13281-0.125 0.23438-0.30469 0.29688-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625 0h-0.375l-1.5-2.25h-0.015625v2.25h-0.35938v-2.8594h0.39062l1.5 2.25v-2.25h0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.3125-2.8594h1.0781c0.16406 0 0.3125 0.011719 0.4375 0.03125 0.125 0.011719 0.23828 0.054687 0.34375 0.125 0.10156 0.074219 0.17969 0.17188 0.23438 0.29688 0.0625 0.11719 0.09375 0.24219 0.09375 0.375 0 0.26172-0.089844 0.47656-0.26562 0.64062-0.16797 0.15625-0.4375 0.23438-0.8125 0.23438h-0.73438v1.1562h-0.375zm0.375 1.3594h0.73438c0.44531 0 0.67188-0.17578 0.67188-0.53125 0-0.11328-0.03125-0.21094-0.09375-0.29688-0.054688-0.082031-0.12109-0.13281-0.20312-0.15625-0.085937-0.03125-0.21094-0.046875-0.375-0.046875h-0.73438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6875-0.92188c0 0.35547-0.074219 0.60547-0.21875 0.75-0.14844 0.14844-0.34375 0.21875-0.59375 0.21875s-0.44531-0.070312-0.57812-0.21875c-0.125-0.14453-0.1875-0.35938-0.1875-0.64062l0.34375-0.046875c0 0.1875 0.035156 0.32812 0.10938 0.42188 0.070312 0.09375 0.17578 0.14062 0.3125 0.14062 0.13281 0 0.23438-0.03125 0.29688-0.09375s0.097656-0.12891 0.10938-0.20312c0.00781-0.082031 0.015625-0.17969 0.015625-0.29688v-1.9688h0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562-1.6719h-0.40625v-0.40625h0.40625zm0 1.6719h-0.40625v-0.40625h0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 0h-0.34375v-2.2344c-0.17969 0.16797-0.41797 0.30859-0.71875 0.42188v-0.34375c0.40625-0.19531 0.67969-0.4375 0.82812-0.71875h0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156-1.5469c0.17578 0.03125 0.30469 0.11719 0.39062 0.25 0.09375 0.13672 0.14062 0.28906 0.14062 0.45312 0 0.26172-0.09375 0.47656-0.28125 0.64062-0.1875 0.16797-0.41406 0.25-0.67188 0.25-0.26172 0-0.47656-0.070312-0.64062-0.21875-0.15625-0.14453-0.25-0.33594-0.28125-0.57812l0.35938-0.0625c0.03125 0.19922 0.09375 0.34375 0.1875 0.4375s0.21875 0.14062 0.375 0.14062 0.28906-0.054687 0.40625-0.17188c0.11328-0.125 0.17188-0.26953 0.17188-0.4375 0-0.15625-0.054687-0.28516-0.15625-0.39062-0.10547-0.10156-0.24219-0.15625-0.40625-0.15625-0.0625 0-0.14062 0.011719-0.23438 0.03125l0.03125-0.3125h0.21875c0.0625-0.00781 0.125-0.03125 0.1875-0.0625 0.070312-0.039063 0.12891-0.09375 0.17188-0.15625 0.039063-0.070313 0.0625-0.15625 0.0625-0.25 0-0.14453-0.046875-0.25391-0.14062-0.32812-0.09375-0.082031-0.20312-0.125-0.32812-0.125-0.13672 0-0.25 0.046875-0.34375 0.14062s-0.15234 0.22656-0.17188 0.39062l-0.34375-0.078125c0.039062-0.23828 0.14062-0.42188 0.29688-0.54688s0.34375-0.1875 0.5625-0.1875c0.23828 0 0.4375 0.074219 0.59375 0.21875 0.15625 0.13672 0.23438 0.30859 0.23438 0.51562 0 0.27344-0.13281 0.46484-0.39062 0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.75 0h-0.39062v-0.40625h0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-0.6875h-0.39062v0.6875h-0.35938v-0.6875h-1.2344v-0.32812l1.2969-1.8438h0.29688v1.8438h0.39062zm-0.75-0.32812v-1.2812l-0.89062 1.2812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156-1.5469c0.35156 0.11719 0.53125 0.35938 0.53125 0.73438 0 0.24219-0.089844 0.44531-0.26562 0.60938-0.16797 0.16797-0.39062 0.25-0.67188 0.25s-0.51172-0.082031-0.6875-0.25c-0.16797-0.16406-0.25-0.375-0.25-0.625 0-0.17578 0.046875-0.33203 0.14062-0.46875 0.10156-0.13281 0.23828-0.21875 0.40625-0.25v-0.015625c-0.29297-0.082031-0.4375-0.27344-0.4375-0.57812 0-0.20703 0.070312-0.37891 0.21875-0.51562 0.15625-0.14453 0.35938-0.21875 0.60938-0.21875s0.44531 0.074219 0.59375 0.21875c0.15625 0.14844 0.23438 0.32422 0.23438 0.53125 0 0.28125-0.14062 0.46875-0.42188 0.5625zm-0.40625-0.14062c0.13281 0 0.24219-0.039062 0.32812-0.125 0.09375-0.082031 0.14062-0.1875 0.14062-0.3125 0-0.13281-0.046875-0.24219-0.14062-0.32812-0.085938-0.09375-0.19531-0.14062-0.32812-0.14062-0.13672 0-0.25 0.046875-0.34375 0.14062-0.085937 0.085937-0.125 0.18359-0.125 0.29688 0 0.14844 0.046875 0.26172 0.14062 0.34375 0.09375 0.085938 0.20312 0.125 0.32812 0.125zm0 1.4531c0.16406 0 0.30078-0.050781 0.40625-0.15625 0.11328-0.11328 0.17188-0.25391 0.17188-0.42188 0-0.17578-0.058594-0.31641-0.17188-0.42188-0.11719-0.11328-0.25-0.17188-0.40625-0.17188-0.17969 0-0.32031 0.058594-0.42188 0.17188-0.10547 0.11719-0.15625 0.25-0.15625 0.40625 0 0.16797 0.050781 0.30859 0.15625 0.42188 0.11328 0.11719 0.25391 0.17188 0.42188 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.64062-1.7188c0.16406-0.125 0.34375-0.1875 0.53125-0.1875 0.23828 0 0.44531 0.089844 0.625 0.26562 0.17578 0.16797 0.26562 0.39062 0.26562 0.67188s-0.089844 0.52344-0.26562 0.71875c-0.17969 0.19922-0.41406 0.29688-0.70312 0.29688-0.24219 0-0.44922-0.066406-0.625-0.20312-0.17969-0.13281-0.27734-0.33203-0.29688-0.59375l0.35938-0.03125c0.03125 0.17969 0.09375 0.3125 0.1875 0.40625 0.10156 0.09375 0.22656 0.14062 0.375 0.14062 0.17578 0 0.31641-0.066406 0.42188-0.20312 0.11328-0.13281 0.17188-0.30078 0.17188-0.5 0-0.19531-0.058594-0.35156-0.17188-0.46875-0.11719-0.125-0.26172-0.1875-0.4375-0.1875-0.21875 0-0.39062 0.09375-0.51562 0.28125l-0.32812-0.046875 0.28125-1.4688h1.4062v0.34375h-1.1406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1094-2.8594-0.82812 2.9531h-0.28125l0.82812-2.9531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1094-2.875c0.625 0 0.9375 0.49219 0.9375 1.4688 0 0.49219-0.085937 0.85547-0.25 1.0938-0.15625 0.24219-0.38672 0.35938-0.6875 0.35938-0.61719 0-0.92188-0.48438-0.92188-1.4531 0-0.5 0.078125-0.86719 0.23438-1.1094 0.15625-0.23828 0.38281-0.35938 0.6875-0.35938zm0 2.6406c0.1875 0 0.32812-0.09375 0.42188-0.28125 0.10156-0.1875 0.15625-0.48438 0.15625-0.89062 0-0.28906-0.023438-0.51953-0.0625-0.6875-0.042969-0.16406-0.10938-0.28906-0.20312-0.375-0.085937-0.082031-0.1875-0.125-0.3125-0.125-0.1875 0-0.32812 0.09375-0.42188 0.28125s-0.14062 0.49219-0.14062 0.90625c0 0.28125 0.019531 0.50781 0.0625 0.67188 0.039063 0.16797 0.10156 0.29297 0.1875 0.375 0.082031 0.085937 0.1875 0.125 0.3125 0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2031-0.85938h-1.0781v-0.35938h1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0312 0h-0.35938v-2.3906h-0.015625l-0.8125 2.3906h-0.34375l-0.82812-2.4375v2.4375h-0.35938v-2.8594h0.5625l0.67188 2.0156c0.070313 0.23047 0.11719 0.375 0.14062 0.4375 0.03125-0.11328 0.082031-0.26953 0.15625-0.46875l0.6875-1.9844h0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625-2.9062c0.39453 0 0.71875 0.13672 0.96875 0.40625 0.25781 0.27344 0.39062 0.63281 0.39062 1.0781 0 0.4375-0.13281 0.79297-0.39062 1.0625-0.25 0.27344-0.57422 0.40625-0.96875 0.40625-0.41797 0-0.75-0.14062-1-0.42188s-0.375-0.61719-0.375-1.0156c0-0.47656 0.125-0.84766 0.375-1.1094 0.25781-0.26953 0.59375-0.40625 1-0.40625zm0 2.625c0.28906 0 0.52344-0.097656 0.70312-0.29688 0.17578-0.20703 0.26562-0.48828 0.26562-0.84375 0-0.375-0.09375-0.66016-0.28125-0.85938-0.17969-0.20703-0.40625-0.3125-0.6875-0.3125s-0.51562 0.10156-0.70312 0.29688c-0.1875 0.19922-0.28125 0.5-0.28125 0.90625 0 0.33594 0.085937 0.60547 0.26562 0.8125 0.1875 0.19922 0.42578 0.29688 0.71875 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.32812-2.8594h0.98438c0.16406 0 0.3125 0.011719 0.4375 0.03125 0.125 0.011719 0.24219 0.054687 0.35938 0.125 0.11328 0.0625 0.21094 0.15625 0.29688 0.28125 0.09375 0.11719 0.16016 0.25 0.20312 0.40625 0.050781 0.15625 0.078125 0.34375 0.078125 0.5625 0 0.42969-0.10156 0.77734-0.29688 1.0469-0.19922 0.27344-0.54297 0.40625-1.0312 0.40625h-1.0312zm0.375 2.5156h0.60938c0.125 0 0.23438-0.003906 0.32812-0.015625 0.10156-0.019531 0.20312-0.0625 0.29688-0.125 0.10156-0.070313 0.1875-0.1875 0.25-0.34375 0.070312-0.15625 0.10938-0.36328 0.10938-0.625 0-0.14453-0.015625-0.28125-0.046875-0.40625-0.023438-0.125-0.070312-0.23438-0.14062-0.32812-0.0625-0.10156-0.14062-0.17969-0.23438-0.23438-0.085938-0.050781-0.16797-0.082031-0.25-0.09375-0.085938-0.007813-0.19531-0.015625-0.32812-0.015625h-0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6719 0h-0.42188l-0.34375-0.875h-1.1875l-0.32812 0.875h-0.39062l1.0938-2.8594h0.40625zm-0.875-1.1719c-0.24219-0.625-0.375-0.97656-0.40625-1.0625-0.023437-0.082031-0.054687-0.19141-0.09375-0.32812h-0.015625c-0.03125 0.1875-0.078125 0.36719-0.14062 0.53125l-0.3125 0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625 0h-0.375v-1.3438h-1.4844v1.3438h-0.375v-2.8594h0.375v1.1719h1.4844v-1.1719h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4531 0h-2.1406v-2.8594h2.0781v0.32812h-1.6875v0.875h1.5781v0.34375h-1.5781v0.96875h1.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156-2.0312c-0.023437-0.17578-0.089844-0.3125-0.20312-0.40625-0.11719-0.09375-0.28125-0.14062-0.5-0.14062-0.19922 0-0.35938 0.039063-0.48438 0.10938-0.11719 0.074219-0.17188 0.18359-0.17188 0.32812 0 0.125 0.046875 0.21875 0.14062 0.28125 0.09375 0.054687 0.27344 0.10938 0.54688 0.17188 0.22656 0.054688 0.41406 0.10547 0.5625 0.15625 0.15625 0.054688 0.28516 0.14062 0.39062 0.26562 0.11328 0.11719 0.17188 0.26562 0.17188 0.45312 0 0.25-0.10156 0.46094-0.29688 0.625-0.19922 0.15625-0.45312 0.23438-0.76562 0.23438-0.40625 0-0.71094-0.085938-0.90625-0.26562-0.19922-0.17578-0.30469-0.41016-0.3125-0.70312l0.35938-0.03125c0.007813 0.23047 0.09375 0.39844 0.25 0.5 0.16406 0.10547 0.36328 0.15625 0.59375 0.15625 0.20703 0 0.375-0.039063 0.5-0.125 0.13281-0.09375 0.20312-0.21094 0.20312-0.35938 0-0.15625-0.070312-0.26953-0.20312-0.34375-0.13672-0.070312-0.36719-0.14062-0.6875-0.20312-0.32422-0.070313-0.55859-0.17188-0.70312-0.29688-0.13672-0.125-0.20312-0.28906-0.20312-0.5 0-0.22656 0.085937-0.41406 0.26562-0.5625 0.17578-0.14453 0.42188-0.21875 0.73438-0.21875 0.32031 0 0.57812 0.074219 0.76562 0.21875 0.19531 0.14844 0.30078 0.35938 0.3125 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.75 0h-0.375v-2.8594h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7031-1.3438c-0.074219 0.10547-0.17188 0.19531-0.29688 0.26562-0.11719 0.074219-0.24609 0.10938-0.39062 0.10938-0.23047 0-0.42969-0.082031-0.59375-0.25-0.16797-0.17578-0.25-0.40625-0.25-0.6875s0.082031-0.50781 0.25-0.6875c0.16406-0.1875 0.38281-0.28125 0.65625-0.28125 0.25781 0 0.48438 0.10547 0.67188 0.3125 0.19531 0.21094 0.29688 0.5625 0.29688 1.0625 0 0.52344-0.089844 0.91406-0.26562 1.1719-0.17969 0.25-0.42969 0.375-0.75 0.375-0.21875 0-0.40234-0.054688-0.54688-0.17188-0.14844-0.125-0.23438-0.30469-0.26562-0.54688l0.34375-0.015625c0.050781 0.30469 0.20703 0.45312 0.46875 0.45312 0.21875 0 0.38281-0.097656 0.5-0.29688 0.11328-0.19531 0.17188-0.46875 0.17188-0.8125zm-0.59375 0.0625c0.16406 0 0.30078-0.054688 0.40625-0.17188 0.10156-0.125 0.15625-0.28125 0.15625-0.46875s-0.054687-0.34375-0.15625-0.46875c-0.10547-0.13281-0.24219-0.20312-0.40625-0.20312-0.15625 0-0.29297 0.070312-0.40625 0.20312-0.11719 0.13672-0.17188 0.30469-0.17188 0.5 0 0.17969 0.050781 0.32422 0.15625 0.4375 0.11328 0.11719 0.25391 0.17188 0.42188 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-2.5469c-0.28125 0.30469-0.52734 0.68359-0.73438 1.1406-0.21094 0.44922-0.32812 0.91797-0.35938 1.4062h-0.35938c0.007812-0.38281 0.10156-0.8125 0.28125-1.2812 0.1875-0.46875 0.42578-0.86719 0.71875-1.2031h-1.4062v-0.34375h1.8594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0156 0h-1.8906c0-0.16406 0.054688-0.32812 0.17188-0.48438 0.11328-0.16406 0.32031-0.375 0.625-0.625 0.1875-0.15625 0.35156-0.31641 0.5-0.48438 0.15625-0.16406 0.23438-0.33203 0.23438-0.5 0-0.14453-0.054688-0.26562-0.15625-0.35938-0.10547-0.09375-0.23438-0.14062-0.39062-0.14062s-0.28906 0.054688-0.39062 0.15625c-0.10547 0.09375-0.16406 0.23438-0.17188 0.42188l-0.35938-0.03125c0.019531-0.26953 0.11328-0.47266 0.28125-0.60938 0.17578-0.14453 0.39453-0.21875 0.65625-0.21875 0.28125 0 0.5 0.078125 0.65625 0.23438s0.23438 0.34375 0.23438 0.5625c0 0.17969-0.070313 0.36719-0.20312 0.5625-0.13672 0.1875-0.39844 0.4375-0.78125 0.75-0.21094 0.16797-0.35156 0.30859-0.42188 0.42188h1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4844 0.34375h-0.25c-0.21875-0.28125-0.39062-0.58203-0.51562-0.90625-0.125-0.33203-0.1875-0.65625-0.1875-0.96875 0-0.36328 0.066406-0.70312 0.20312-1.0156 0.13281-0.3125 0.30078-0.59766 0.5-0.85938h0.25c-0.23047 0.375-0.38672 0.71094-0.46875 1-0.074219 0.28125-0.10938 0.57031-0.10938 0.85938 0 0.63672 0.19141 1.2656 0.57812 1.8906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.8438-0.1875-0.25 0.21875c-0.42969-0.35156-0.71094-0.82031-0.84375-1.4062v1.625h-0.3125v-1.5312c-0.09375 0.39844-0.40234 0.82422-0.92188 1.2812l-0.21875-0.23438c0.46875-0.39453 0.76953-0.83203 0.90625-1.3125h-0.65625v-0.29688h0.90625v-0.5625h-0.39062c-0.074219 0.17969-0.16797 0.34375-0.28125 0.5l-0.29688-0.14062c0.25-0.26953 0.38281-0.62891 0.40625-1.0781l0.29688 0.09375c-0.011719 0.11719-0.027344 0.22656-0.046875 0.32812h0.3125v-0.64062h0.29688v0.64062h0.71875v0.29688h-0.71875v0.5625h0.92188v0.29688h-0.67188c0.14453 0.58594 0.42578 1.0391 0.84375 1.3594zm-2.1719-1.0625-0.26562 0.17188c-0.0625-0.20703-0.15234-0.36719-0.26562-0.48438v1.8125h-0.3125v-1.6875c-0.0625 0.1875-0.22656 0.42188-0.48438 0.70312l-0.23438-0.1875c0.38281-0.40625 0.625-0.85938 0.71875-1.3594h-0.54688v-0.29688h0.54688v-0.76562h0.3125v0.76562h0.4375v0.29688h-0.4375v0.40625l0.03125-0.03125c0.14453 0.085938 0.3125 0.30469 0.5 0.65625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7812-3.4062c0.21875 0.27344 0.39062 0.57422 0.51562 0.90625 0.125 0.32422 0.1875 0.64844 0.1875 0.96875 0 0.35547-0.070313 0.6875-0.20312 1-0.125 0.3125-0.29297 0.60156-0.5 0.875h-0.25c0.23828-0.38281 0.39453-0.71875 0.46875-1 0.082031-0.28906 0.125-0.58203 0.125-0.875 0-0.63281-0.19922-1.2578-0.59375-1.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3594-2.5312h-0.95312v2.5312h-0.375v-2.5312h-0.9375v-0.32812h2.2656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6406 0h-0.46875l-0.5625-0.8125c-0.14844-0.19531-0.23438-0.33203-0.26562-0.40625h-0.015625c0 0.03125-0.28125 0.4375-0.84375 1.2188h-0.46875l1.1094-1.5-0.96875-1.3594h0.4375l0.60938 0.84375c0.0625 0.09375 0.10938 0.17188 0.14062 0.23438 0.050781-0.082031 0.32031-0.44141 0.8125-1.0781h0.40625l-1 1.3438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3906-2.6562-0.28125 0.10938c-0.042969-0.21875-0.10547-0.39453-0.1875-0.53125l0.29688-0.125c0.070312 0.14844 0.12891 0.32812 0.17188 0.54688zm-1.3594-0.125-0.125 0.375c-0.34375-0.20703-0.75-0.33203-1.2188-0.375l0.14062-0.375c0.50781 0.10547 0.91016 0.23047 1.2031 0.375zm0.90625 0.28125-0.26562 0.125c-0.054687-0.22656-0.11719-0.41016-0.1875-0.54688l0.28125-0.10938c0.070313 0.14844 0.12891 0.32422 0.17188 0.53125zm0.65625 0.5c-0.36719 0.58594-0.77734 1.0469-1.2344 1.3906-0.46094 0.33594-1.0156 0.58984-1.6719 0.76562l-0.1875-0.375c0.67578-0.15625 1.2383-0.39453 1.6875-0.71875 0.45703-0.33203 0.82031-0.76953 1.0938-1.3125zm-1.9375 0.23438-0.14062 0.375c-0.30469-0.21875-0.70312-0.35156-1.2031-0.40625l0.125-0.35938c0.5 0.09375 0.90625 0.22656 1.2188 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.1562-1.875-0.5 1.1406-0.3125-0.14062 0.32812-0.73438-0.67188 0.125 0.35938 1.5781-0.32812 0.09375-0.35938-1.5938-0.79688 0.14062-0.0625-0.32812 0.78125-0.14062-0.10938-0.5625 0.32812-0.078125 0.10938 0.5625 1.0469-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3438-3.3438c0.11328 0 0.21094 0.042969 0.29688 0.125 0.09375 0.085938 0.14062 0.18359 0.14062 0.29688 0 0.11719-0.046875 0.21484-0.14062 0.29688-0.085937 0.085938-0.18359 0.125-0.29688 0.125-0.11719 0-0.21484-0.039062-0.29688-0.125-0.085937-0.082031-0.125-0.17969-0.125-0.29688 0-0.11328 0.039063-0.21094 0.125-0.29688 0.082031-0.082031 0.17969-0.125 0.29688-0.125zm0 0.57812c0.050781 0 0.09375-0.00781 0.125-0.03125 0.03125-0.03125 0.046875-0.070313 0.046875-0.125 0-0.050781-0.015625-0.09375-0.046875-0.125s-0.074219-0.046875-0.125-0.046875c-0.054688 0-0.09375 0.015625-0.125 0.046875-0.023438 0.03125-0.03125 0.074219-0.03125 0.125 0 0.054687 0.00781 0.09375 0.03125 0.125 0.03125 0.023437 0.070312 0.03125 0.125 0.03125zm-1.75-0.28125c-0.074219 0.59375-0.21094 1.1836-0.40625 1.7656-0.1875 0.58594-0.41406 1.0547-0.67188 1.4062l-0.32812-0.21875c0.28125-0.39453 0.51562-0.86328 0.70312-1.4062 0.1875-0.53906 0.30078-1.0977 0.34375-1.6719zm1.9531 2.9688-0.39062 0.09375c-0.042969-0.42578-0.15625-0.91406-0.34375-1.4688-0.17969-0.55078-0.39844-1.0664-0.65625-1.5469l0.34375-0.15625c0.53906 1.1562 0.89062 2.1836 1.0469 3.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7812-2.4375-0.21875 0.3125c-0.32422-0.26953-0.70312-0.45703-1.1406-0.5625l0.23438-0.32812c0.45703 0.16797 0.83203 0.35938 1.125 0.57812zm1.7969 0.40625c-0.46094 0.6875-0.91406 1.1836-1.3594 1.4844-0.44922 0.29297-0.96094 0.52344-1.5312 0.6875l-0.23438-0.375c0.71875-0.14453 1.2891-0.38281 1.7188-0.71875 0.42578-0.34375 0.80078-0.78516 1.125-1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1875 0.84375h-0.25c-0.21875-0.28125-0.39062-0.58594-0.51562-0.90625-0.125-0.33203-0.1875-0.65625-0.1875-0.96875 0-0.36328 0.066406-0.70312 0.20312-1.0156 0.13281-0.3125 0.30078-0.59766 0.5-0.85938h0.25c-0.23047 0.375-0.38672 0.71094-0.46875 1-0.074219 0.28125-0.10938 0.57031-0.10938 0.85938 0 0.63672 0.19141 1.2656 0.57812 1.8906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.39062-2.9062c0.21875 0.27344 0.39062 0.57422 0.51562 0.90625 0.125 0.32422 0.1875 0.64844 0.1875 0.96875 0 0.35547-0.070312 0.6875-0.20312 1-0.125 0.3125-0.29297 0.60156-0.5 0.875h-0.25c0.23828-0.38672 0.39453-0.71875 0.46875-1 0.082031-0.28906 0.125-0.58203 0.125-0.875 0-0.63281-0.19922-1.2578-0.59375-1.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1875-0.78125h-0.60938l-0.17188 0.82812h-0.29688l0.17188-0.82812h-0.60938l-0.17188 0.82812h-0.29688l0.17188-0.82812h-0.32812v-0.29688h0.39062l0.14062-0.70312h-0.53125v-0.29688h0.59375l0.17188-0.82812h0.28125l-0.15625 0.82812h0.60938l0.17188-0.82812h0.29688l-0.17188 0.82812h0.34375v0.29688h-0.40625l-0.14062 0.70312h0.54688zm-0.70312-1h-0.60938l-0.14062 0.70312h0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8438 0h-0.46875c-0.29297-0.44531-0.47656-0.72266-0.54688-0.82812-0.0625-0.10156-0.13672-0.19141-0.21875-0.26562-0.074219-0.070312-0.14844-0.11719-0.21875-0.14062-0.0625-0.019531-0.14844-0.03125-0.25-0.03125h-0.4375v1.2656h-0.375v-2.8594h1.2656c0.16406 0 0.30469 0.011719 0.42188 0.03125 0.125 0.023437 0.22656 0.070313 0.3125 0.14062 0.09375 0.074219 0.16016 0.16406 0.20312 0.26562 0.050781 0.10547 0.078125 0.21875 0.078125 0.34375 0 0.21875-0.070313 0.39844-0.20312 0.53125-0.13672 0.125-0.33594 0.20312-0.59375 0.23438v0.015625c0.1875 0.085937 0.36328 0.25781 0.53125 0.51562zm-2.1406-1.6094h0.8125c0.16406 0 0.29688-0.00781 0.39062-0.03125 0.09375-0.03125 0.16406-0.085937 0.21875-0.17188 0.0625-0.082031 0.09375-0.17188 0.09375-0.26562 0-0.13281-0.046875-0.24219-0.14062-0.32812-0.09375-0.09375-0.25-0.14062-0.46875-0.14062h-0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3438 0h-2.2656v-0.35938l1.4688-1.8281s0.03125-0.039062 0.09375-0.125c0.070313-0.082031 0.14062-0.15625 0.20312-0.21875h-1.6094v-0.32812h2.0469v0.32812l-1.5938 1.9844-0.17188 0.20312h1.8281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4531 0h-2.1406v-2.8594h2.0781v0.32812h-1.6875v0.875h1.5781v0.34375h-1.5781v0.96875h1.75zm-0.60938-3.5938-0.4375 0.54688h-0.29688l0.26562-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938 0h-1.7969v-2.8594h0.39062v2.5156h1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562 0c0 0.16406-0.03125 0.28906-0.09375 0.375-0.0625 0.09375-0.14062 0.15625-0.23438 0.1875l-0.09375-0.14062c0.14453-0.0625 0.21875-0.20312 0.21875-0.42188h-0.20312v-0.40625h0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.9844-0.046875-0.10938 0.26562c-0.23047-0.085938-0.4375-0.19922-0.625-0.34375-0.21094 0.11719-0.44531 0.17188-0.70312 0.17188-0.39844 0-0.72656-0.13281-0.98438-0.40625-0.25-0.28125-0.375-0.64062-0.375-1.0781 0-0.42578 0.125-0.77344 0.375-1.0469 0.25-0.28125 0.58203-0.42188 1-0.42188 0.39453 0 0.71875 0.13672 0.96875 0.40625 0.25781 0.27344 0.39062 0.625 0.39062 1.0625 0 0.46875-0.14062 0.84375-0.42188 1.125 0.15625 0.11719 0.31641 0.20312 0.48438 0.26562zm-0.78125-0.46875c0.21875-0.20703 0.32812-0.51562 0.32812-0.92188 0-0.35156-0.089844-0.63281-0.26562-0.84375-0.17969-0.20703-0.41406-0.3125-0.70312-0.3125-0.29297 0-0.53125 0.10156-0.71875 0.29688-0.17969 0.19922-0.26562 0.48438-0.26562 0.85938s0.085937 0.66406 0.26562 0.85938c0.1875 0.19922 0.42578 0.29688 0.71875 0.29688 0.14453 0 0.26953-0.023438 0.375-0.078125-0.125-0.070313-0.25-0.125-0.375-0.15625l0.09375-0.28125c0.23828 0.074219 0.42188 0.16797 0.54688 0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625-1.2031c0 0.14844-0.011719 0.28125-0.03125 0.40625-0.011719 0.125-0.054688 0.25781-0.125 0.39062-0.0625 0.125-0.17188 0.23438-0.32812 0.32812-0.15625 0.082031-0.36719 0.125-0.625 0.125-0.26172 0-0.46875-0.039062-0.625-0.10938-0.15625-0.082031-0.27344-0.1875-0.34375-0.3125-0.074219-0.125-0.12109-0.25-0.14062-0.375-0.023438-0.13281-0.03125-0.28516-0.03125-0.45312v-1.6562h0.39062v1.6406c0 0.17969 0.007813 0.32812 0.03125 0.45312 0.019531 0.125 0.082031 0.23438 0.1875 0.32812 0.11328 0.09375 0.28125 0.14062 0.5 0.14062s0.38281-0.035156 0.5-0.10938c0.11328-0.082031 0.1875-0.1875 0.21875-0.3125s0.046875-0.28906 0.046875-0.5v-1.6406h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-1.5312c0.17578 0.0625 0.3125 0.15625 0.40625 0.28125 0.09375 0.11719 0.14062 0.25781 0.14062 0.42188 0 0.15625-0.042969 0.30469-0.125 0.4375-0.085938 0.13672-0.19922 0.23438-0.34375 0.29688-0.14844 0.0625-0.35156 0.09375-0.60938 0.09375h-1.0938v-2.8594h1.0781c0.34375 0 0.58594 0.078125 0.73438 0.23438 0.14453 0.14844 0.21875 0.30859 0.21875 0.48438 0 0.125-0.039063 0.24609-0.10938 0.35938-0.0625 0.10547-0.16406 0.1875-0.29688 0.25zm-1.25-0.14062h0.625c0.125 0 0.22656-0.00391 0.3125-0.015625 0.09375-0.00781 0.17188-0.046875 0.23438-0.10938 0.070312-0.0625 0.10938-0.15625 0.10938-0.28125 0-0.13281-0.039063-0.23438-0.10938-0.29688-0.0625-0.070312-0.14062-0.11328-0.23438-0.125-0.09375-0.019531-0.21484-0.03125-0.35938-0.03125h-0.57812zm0 1.3281h0.71875c0.25 0 0.42188-0.039062 0.51562-0.125 0.10156-0.09375 0.15625-0.21094 0.15625-0.35938 0-0.15625-0.054688-0.27344-0.15625-0.35938-0.10547-0.09375-0.29297-0.14062-0.5625-0.14062h-0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8594-0.40625c-0.36719 0.30469-0.76172 0.45312-1.1875 0.45312-0.4375 0-0.79297-0.12891-1.0625-0.39062-0.27344-0.26953-0.40625-0.62891-0.40625-1.0781 0-0.26953 0.050781-0.51953 0.15625-0.75 0.11328-0.23828 0.28125-0.42188 0.5-0.54688s0.47656-0.1875 0.78125-0.1875c0.32031 0 0.58203 0.074219 0.78125 0.21875 0.19531 0.13672 0.32812 0.34375 0.39062 0.625l-0.34375 0.09375c-0.054688-0.20703-0.14844-0.36328-0.28125-0.46875-0.13672-0.10156-0.32031-0.15625-0.54688-0.15625-0.34375 0-0.60547 0.10938-0.78125 0.32812-0.17969 0.21094-0.26562 0.48438-0.26562 0.82812 0 0.25 0.039062 0.46484 0.125 0.64062 0.09375 0.16797 0.22266 0.29297 0.39062 0.375 0.16406 0.085937 0.34766 0.125 0.54688 0.125 0.30078 0 0.57812-0.097656 0.82812-0.29688v-0.53125h-0.84375v-0.34375h1.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6406-2.8594-1.1406 1.6406v1.2188h-0.375v-1.2188l-1.1094-1.6406h0.46875l0.625 0.95312c0.0625 0.10547 0.14062 0.23438 0.23438 0.39062 0.050781-0.10156 0.33594-0.55078 0.85938-1.3438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-1.3906h-0.64062v1.6719h-0.29688v-3.6562h0.29688v1.6719h0.64062zm-1.5156-0.25c0 0.33594-0.089844 0.62109-0.26562 0.85938-0.17969 0.24219-0.39062 0.35938-0.64062 0.35938s-0.46484-0.11328-0.64062-0.34375c-0.16797-0.23828-0.25-0.53125-0.25-0.875 0-0.36328 0.082031-0.65625 0.25-0.875 0.16406-0.22656 0.37891-0.34375 0.64062-0.34375 0.25 0 0.46094 0.12109 0.64062 0.35938 0.17578 0.23047 0.26562 0.51562 0.26562 0.85938zm-0.29688 0c0-0.25-0.0625-0.46094-0.1875-0.64062-0.11719-0.17578-0.25781-0.26562-0.42188-0.26562-0.16797 0-0.30859 0.089844-0.42188 0.26562-0.11719 0.17969-0.17188 0.39062-0.17188 0.64062s0.054687 0.46484 0.17188 0.64062c0.11328 0.17969 0.25391 0.26562 0.42188 0.26562 0.16406 0 0.30469-0.085937 0.42188-0.26562 0.125-0.17578 0.1875-0.39062 0.1875-0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 0.28125h-0.29688v-3.6562h0.29688zm-1.0469-1.9219c0 0.375-0.10156 0.6875-0.29688 0.9375-0.1875 0.25-0.42188 0.375-0.70312 0.375-0.3125 0-0.57031-0.11719-0.76562-0.35938-0.1875-0.23828-0.28125-0.55469-0.28125-0.95312 0-0.40625 0.09375-0.72266 0.28125-0.95312 0.19531-0.23828 0.45312-0.35938 0.76562-0.35938 0.28906 0 0.53125 0.12109 0.71875 0.35938 0.1875 0.24219 0.28125 0.55859 0.28125 0.95312zm-0.32812 0c0-0.28125-0.0625-0.51562-0.1875-0.70312s-0.28906-0.28125-0.48438-0.28125c-0.21094 0-0.38281 0.10156-0.51562 0.29688-0.125 0.1875-0.1875 0.41797-0.1875 0.6875 0 0.26172 0.0625 0.49219 0.1875 0.6875 0.13281 0.19922 0.30469 0.29688 0.51562 0.29688 0.1875 0 0.34375-0.09375 0.46875-0.28125 0.13281-0.19531 0.20312-0.42969 0.20312-0.70312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 0.28125h-0.29688v-3.6562h0.29688zm-0.85938-1.0312c-0.32422 0.054688-0.72656 0.10156-1.2031 0.14062-0.46875 0.042969-0.82422 0.0625-1.0625 0.0625v-2.3594h2.0938v0.3125h-1.7656v0.60938h1.6875v0.32812h-1.6875v0.76562c0.71875-0.019531 1.3633-0.078125 1.9375-0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625-1.25h-0.29688v-2.125h0.29688zm-0.59375-0.015625h-0.3125v-0.84375h-0.53125v-0.3125h0.53125v-0.85938h0.3125zm-0.98438-1c0 0.23047-0.085937 0.42969-0.25 0.59375-0.15625 0.15625-0.36719 0.23438-0.625 0.23438-0.27344 0-0.48438-0.070312-0.64062-0.21875-0.15625-0.15625-0.23438-0.35156-0.23438-0.59375 0-0.25 0.082031-0.44531 0.25-0.59375 0.16406-0.15625 0.375-0.23438 0.625-0.23438 0.25781 0 0.46875 0.078125 0.625 0.23438 0.16406 0.15625 0.25 0.35156 0.25 0.57812zm-0.29688 0c0-0.13281-0.058594-0.25391-0.17188-0.35938-0.11719-0.10156-0.25-0.15625-0.40625-0.15625s-0.29297 0.054688-0.40625 0.15625c-0.11719 0.10547-0.17188 0.22656-0.17188 0.35938 0 0.14844 0.054688 0.27344 0.17188 0.375 0.11328 0.10547 0.25 0.15625 0.40625 0.15625s0.28906-0.050781 0.40625-0.15625c0.11328-0.10156 0.17188-0.22656 0.17188-0.375zm1.5781 2.5156v-1h-2.3125v-0.3125h2.6094v1.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938-2.4688c0.125 0.21094 0.33594 0.42188 0.64062 0.64062 0.30078 0.21094 0.60156 0.35156 0.90625 0.42188-0.11719 0.11719-0.19531 0.22656-0.23438 0.32812-0.27344-0.10156-0.54688-0.25391-0.82812-0.45312-0.27344-0.19531-0.48047-0.39453-0.625-0.59375-0.33594 0.5-0.78906 0.85938-1.3594 1.0781-0.0625-0.11328-0.13672-0.20312-0.21875-0.26562 0.45703-0.15625 0.8125-0.37891 1.0625-0.67188 0.25781-0.30078 0.39062-0.62891 0.39062-0.98438l0.4375 0.078125c-0.054687 0.085937-0.10938 0.22656-0.17188 0.42188zm1.6719 2.2656h-3.5312v-0.32812h3.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2812-2.9062c0.00781 0.6875-0.070312 1.4141-0.23438 2.1719-0.0625 0-0.18359-0.007813-0.35938-0.03125 0.0625-0.20703 0.11719-0.5 0.17188-0.875-1.0859 0.125-1.7891 0.19531-2.1094 0.20312l-0.0625-0.39062c0.50781 0.011719 1.2422-0.019531 2.2031-0.09375 0.03125-0.26953 0.046875-0.48828 0.046875-0.65625h-2.1719v-0.32812zm0.48438 2.8125h-3.5156v-0.3125h1.5938v-0.85938h0.3125v0.85938h1.6094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 0.28125h-0.29688v-3.6562h0.29688zm-3.0469-0.42188v-1.7188h1.75v-0.78125h-1.75v-0.32812h2.0625v1.4219h-1.75v1.0781c0.73828-0.03125 1.4258-0.125 2.0625-0.28125v0.32812c-0.61719 0.14844-1.4062 0.24219-2.375 0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3281 0.28125v-1.9062h-1.2031v-0.3125h1.2031v-1.4219h0.29688v3.6406zm-1.0781-0.60938c-0.34375-0.30078-0.625-0.72266-0.84375-1.2656-0.21875 0.5625-0.52344 1.0273-0.90625 1.3906-0.09375-0.15625-0.18359-0.25391-0.26562-0.29688 0.30078-0.19531 0.54688-0.5 0.73438-0.90625s0.28125-0.76953 0.28125-1.0938l-0.015625-0.3125v-0.21875l0.42188 0.046875c-0.085938 0.15625-0.125 0.44922-0.125 0.875 0 0.054687 0.046875 0.17969 0.14062 0.375 0.09375 0.1875 0.17969 0.35156 0.26562 0.48438 0.082031 0.125 0.17188 0.24609 0.26562 0.35938 0.10156 0.10547 0.20703 0.19531 0.3125 0.26562-0.11719 0.085938-0.20312 0.18359-0.26562 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3281-2.5781c0 0.17969-0.13281 0.33594-0.39062 0.46875-0.25 0.125-0.5625 0.1875-0.9375 0.1875-0.38672 0-0.70312-0.0625-0.95312-0.1875-0.24219-0.125-0.35938-0.28125-0.35938-0.46875 0-0.17578 0.125-0.32812 0.375-0.45312 0.25781-0.13281 0.57031-0.20312 0.9375-0.20312 0.36328 0 0.67578 0.070313 0.9375 0.20312 0.25781 0.125 0.39062 0.27734 0.39062 0.45312zm-0.375 0c0-0.09375-0.09375-0.17188-0.28125-0.23438-0.17969-0.070312-0.40234-0.10938-0.67188-0.10938-0.27344 0-0.49609 0.039063-0.67188 0.10938-0.17969 0.0625-0.26562 0.14062-0.26562 0.23438s0.085938 0.17969 0.26562 0.25c0.17578 0.0625 0.39844 0.09375 0.67188 0.09375 0.26953 0 0.49219-0.03125 0.67188-0.09375 0.1875-0.070313 0.28125-0.15625 0.28125-0.25zm0.73438 1.1094h-1.5312v0.28125h-0.3125v-0.28125h-1.5312v-0.3125h3.375zm-0.45312 0.34375v0.79688h-2.1875v0.26562h2.2344v0.3125h-2.5312v-0.89062h2.1719v-0.1875h-2.1875v-0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 0.28125h-0.29688v-3.6562h0.29688zm-1.0156-0.76562c-0.38672-0.30078-0.70312-0.72266-0.95312-1.2656-0.24219 0.5625-0.57812 1.0273-1.0156 1.3906-0.10547-0.13281-0.19922-0.22266-0.28125-0.26562 0.33203-0.20703 0.60156-0.50781 0.8125-0.90625 0.21875-0.40625 0.32812-0.76953 0.32812-1.0938 0-0.25-0.011719-0.41406-0.03125-0.5l0.45312 0.046875c-0.054687 0.10547-0.089844 0.20312-0.10938 0.29688-0.011719 0.09375-0.015625 0.27734-0.015625 0.54688 0 0.042969 0.035156 0.14062 0.10938 0.29688 0.082031 0.15625 0.15625 0.28906 0.21875 0.39062 0.070312 0.10547 0.14453 0.21094 0.21875 0.3125 0.082031 0.09375 0.17188 0.18359 0.26562 0.26562 0.09375 0.085938 0.1875 0.15625 0.28125 0.21875-0.125 0.074219-0.21875 0.16406-0.28125 0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-2.1562h-0.64062v0.90625h-0.29688v-2.0938h0.29688v0.89062h0.64062zm-3.1875 0.90625-0.20312-0.26562c0.3125-0.10156 0.60156-0.28125 0.875-0.53125 0.26953-0.25781 0.44531-0.51562 0.53125-0.76562h-1.2812v-0.3125h1.7188c-0.074219 0.40625-0.26172 0.77734-0.5625 1.1094-0.29297 0.33594-0.65234 0.58984-1.0781 0.76562zm2.625 0.79688c0 0.21875-0.10938 0.39062-0.32812 0.51562-0.21875 0.13281-0.50781 0.20312-0.85938 0.20312-0.36719 0-0.66406-0.0625-0.89062-0.1875-0.21875-0.125-0.32812-0.30078-0.32812-0.53125 0-0.19531 0.11328-0.36719 0.34375-0.51562 0.22656-0.14453 0.51953-0.21875 0.875-0.21875 0.34375 0 0.625 0.070312 0.84375 0.20312 0.22656 0.13672 0.34375 0.3125 0.34375 0.53125zm-0.35938 0.015625c0-0.125-0.078125-0.22266-0.23438-0.29688-0.14844-0.082031-0.34375-0.125-0.59375-0.125-0.26172 0-0.46875 0.042969-0.625 0.125-0.15625 0.074219-0.23438 0.17188-0.23438 0.29688 0 0.11719 0.078125 0.21484 0.23438 0.29688 0.16406 0.074219 0.375 0.10938 0.625 0.10938s0.44531-0.035156 0.59375-0.10938c0.15625-0.082031 0.23438-0.17969 0.23438-0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-2.1719h-0.64062v0.92188h-0.29688v-2.125h0.29688v0.89062h0.64062zm-3-0.79688v1.0938c0.42578 0.011719 1.0352-0.03125 1.8281-0.125v0.29688c-0.65625 0.085937-1.3711 0.13281-2.1406 0.14062v-1.4062zm2.0625 3.2188v-0.14062h-1.6406v0.14062h-0.29688v-1.375h2.2344v1.375zm0-1.0625h-1.6406v0.60938h1.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6875-1.3438h-1.5312v1.5938h-0.3125v-1.5938h-1.5312v-0.3125h2.4375c0.11328-0.61328 0.17188-0.99219 0.17188-1.1406h-2.3438v-0.32812h2.7031c-0.011719 0.25-0.078125 0.74219-0.20312 1.4688h0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6406-1.2344h-0.3125v-0.60938h-0.79688v-0.3125h0.79688v-0.29688h-0.79688v-0.29688h0.79688v-0.625h0.3125zm-1.4531-1.0312c0 0.25-0.085938 0.46094-0.25 0.625-0.16797 0.16797-0.39062 0.25-0.67188 0.25s-0.50781-0.078125-0.67188-0.23438c-0.15625-0.16406-0.23438-0.37891-0.23438-0.64062 0-0.23828 0.082031-0.44141 0.25-0.60938 0.17578-0.16406 0.39453-0.25 0.65625-0.25 0.26953 0 0.48828 0.085938 0.65625 0.25 0.17578 0.16797 0.26562 0.37109 0.26562 0.60938zm-0.29688 0c0-0.15625-0.0625-0.28516-0.1875-0.39062-0.11719-0.11328-0.25781-0.17188-0.42188-0.17188-0.17969 0-0.32812 0.058594-0.45312 0.17188-0.11719 0.10547-0.17188 0.23438-0.17188 0.39062s0.054688 0.29297 0.17188 0.40625c0.125 0.10547 0.27344 0.15625 0.45312 0.15625 0.16406 0 0.30469-0.050781 0.42188-0.15625 0.125-0.11328 0.1875-0.25 0.1875-0.40625zm1.75 1.8281c0 0.21875-0.125 0.39062-0.375 0.51562s-0.57422 0.1875-0.96875 0.1875c-0.41797 0-0.75-0.0625-1-0.1875-0.24219-0.125-0.35938-0.29688-0.35938-0.51562s0.12891-0.39453 0.39062-0.53125c0.26953-0.13281 0.59375-0.20312 0.96875-0.20312 0.39453 0 0.71875 0.070313 0.96875 0.20312 0.25 0.125 0.375 0.30469 0.375 0.53125zm-0.32812 0c0-0.11328-0.10156-0.21094-0.29688-0.29688-0.19922-0.082031-0.4375-0.125-0.71875-0.125-0.27344 0-0.51172 0.039063-0.71875 0.10938-0.21094 0.074219-0.3125 0.17969-0.3125 0.3125 0 0.10547 0.10938 0.19922 0.32812 0.28125 0.21875 0.085938 0.45312 0.125 0.70312 0.125 0.28125 0 0.51953-0.039062 0.71875-0.125 0.19531-0.082031 0.29688-0.17578 0.29688-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6875-1.3281h-3.375v-0.28125h1.5312v-0.28125h-1.1406v-1.2656h2.5469v0.3125h-2.2188v0.625h2.25v0.32812h-1.125v0.28125h1.5312zm-0.32812 0.89062c0 0.21875-0.125 0.39062-0.375 0.51562s-0.57422 0.1875-0.96875 0.1875c-0.41797 0-0.75-0.0625-1-0.1875s-0.375-0.29688-0.375-0.51562 0.13281-0.39453 0.40625-0.53125c0.26953-0.13281 0.59375-0.20312 0.96875-0.20312 0.38281 0 0.70312 0.070313 0.95312 0.20312 0.25781 0.125 0.39062 0.30469 0.39062 0.53125zm-1.3125-0.42188c-0.30469 0-0.55859 0.039063-0.76562 0.10938-0.19922 0.074219-0.29688 0.17969-0.29688 0.3125 0 0.10547 0.10156 0.19922 0.3125 0.28125 0.21875 0.085938 0.45703 0.125 0.71875 0.125 0.26953 0 0.50391-0.039062 0.70312-0.125 0.20703-0.082031 0.3125-0.17578 0.3125-0.28125 0-0.11328-0.10156-0.21094-0.29688-0.29688-0.1875-0.082031-0.41797-0.125-0.6875-0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 0.28125h-0.29688v-1.7031h-0.5v1.4844h-0.29688v-3.2344h0.29688v1.4375h0.5v-1.6406h0.29688zm-1.5156-2.7812h-1.3594v1.8438c0.41406 0 0.94531-0.046875 1.5938-0.14062v0.29688c-0.60547 0.10547-1.2422 0.16797-1.9062 0.1875v-2.5h1.6719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7656-0.10938h-3.5156v-0.3125h1.5938v-0.64062h-1.1094v-1.1406h2.1406v-0.5h-2.1406v-0.3125h2.4531v1.125h-2.1406v0.51562h2.2344v0.3125h-1.125v0.64062h1.6094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2969-0.98438h-2.5469v-1.8906h2.5v0.3125h-2.1875v0.48438h2.0781v0.3125h-2.0781v0.46875h2.2344zm0.46875 0.78125h-3.5312v-0.32812h3.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3281 0.26562v-3.6406h0.29688v3.6406zm-0.75-0.21875v-1.4375h-0.53125v-0.3125h0.53125v-1.6094h0.3125v3.3594zm-2.0938-0.20312v-1.8281h1.1875v-0.73438h-1.2031v-0.32812h1.5156v1.375h-1.1875v1.1875c0.42578-0.007813 0.89062-0.078125 1.3906-0.20312v0.29688c-0.46875 0.13672-1.0391 0.21484-1.7031 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.25-2.5156h-2.2188v1.1094h2.25c0.00781 0.085938 0.00781 0.1875 0 0.3125h-2.5781v-1.75h2.5469zm0.51562 2.3438h-3.5312v-0.3125h3.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3281-0.67188v-2.7031h0.3125v2.7031zm-0.6875-0.21875v-1.25h-0.6875v-0.3125h0.6875v-0.84375h0.3125v2.4062zm-1.1562-1.5469c0.0625 0.1875 0.1875 0.39844 0.375 0.625 0.19531 0.21875 0.39062 0.38672 0.57812 0.5-0.10547 0.042969-0.19531 0.125-0.26562 0.25-0.30469-0.20703-0.58594-0.51953-0.84375-0.9375-0.17969 0.375-0.46094 0.70312-0.84375 0.98438-0.074219-0.10156-0.15625-0.19141-0.25-0.26562 0.23828-0.14453 0.4375-0.32031 0.59375-0.53125 0.16406-0.20703 0.26953-0.39844 0.3125-0.57812 0.050781-0.1875 0.078125-0.41406 0.078125-0.6875l0.39062 0.046875c-0.03125 0.054688-0.0625 0.16406-0.09375 0.32812-0.023437 0.16797-0.03125 0.25781-0.03125 0.26562zm2.1406 2.625h-2.6562v-1.2188h0.3125v0.89062h2.3438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.3281 0.28125v-1.6719h-0.90625v-0.3125h0.90625v-1.6562h0.29688v3.6406zm-0.75-0.84375c-0.30469 0.042969-0.67969 0.085938-1.125 0.125-0.44922 0.03125-0.77734 0.046875-0.98438 0.046875v-2.5h1.9219v0.3125h-1.6094v0.70312h1.5312v0.3125h-1.5312v0.85938c0.46875 0 1.0664-0.054687 1.7969-0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5938-2.8906h-1.1875v-0.3125h1.1875zm0.90625 0.92188-0.29688 0.3125c-0.52344-0.11328-0.92188-0.32031-1.2031-0.625-0.3125 0.32422-0.72656 0.53906-1.2344 0.64062-0.09375-0.15625-0.17188-0.25391-0.23438-0.29688 0.55078-0.10156 0.92578-0.25781 1.125-0.46875h-1.0938v-0.32812h2.875v0.32812h-1.0938c0.22656 0.21875 0.61328 0.36719 1.1562 0.4375zm0.1875 0.70312h-3.375v-0.3125h3.375zm-0.32812 0.82812c0 0.21875-0.125 0.39062-0.375 0.51562s-0.57422 0.1875-0.96875 0.1875c-0.41797 0-0.75-0.0625-1-0.1875s-0.375-0.29688-0.375-0.51562 0.13281-0.39453 0.40625-0.53125c0.26953-0.13281 0.59375-0.20312 0.96875-0.20312 0.38281 0 0.70312 0.070313 0.95312 0.20312 0.25781 0.125 0.39062 0.30469 0.39062 0.53125zm-1.3125-0.42188c-0.30469 0-0.55859 0.039063-0.76562 0.10938-0.19922 0.074219-0.29688 0.17969-0.29688 0.3125 0 0.10547 0.10156 0.19922 0.3125 0.28125 0.21875 0.085938 0.45703 0.125 0.71875 0.125 0.26953 0 0.50391-0.039062 0.70312-0.125 0.20703-0.082031 0.3125-0.17578 0.3125-0.28125 0-0.11328-0.10156-0.21094-0.29688-0.29688-0.1875-0.082031-0.41797-0.125-0.6875-0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.53125-1.4844c0.15625-0.25 0.38281-0.375 0.6875-0.375 0.22656 0 0.42578 0.089844 0.59375 0.26562 0.16406 0.16797 0.25 0.38672 0.25 0.65625 0 0.27344-0.085938 0.50781-0.25 0.70312-0.16797 0.1875-0.38672 0.28125-0.65625 0.28125-0.27344 0-0.50781-0.097656-0.70312-0.29688-0.1875-0.20703-0.28125-0.57031-0.28125-1.0938 0-0.50781 0.082031-0.89062 0.25-1.1406 0.17578-0.25781 0.42969-0.39062 0.76562-0.39062 0.21875 0 0.39844 0.0625 0.54688 0.1875 0.14453 0.11719 0.23828 0.28906 0.28125 0.51562l-0.35938 0.03125c-0.0625-0.30078-0.22656-0.45312-0.48438-0.45312-0.17969 0-0.33594 0.09375-0.46875 0.28125-0.125 0.17969-0.1875 0.45312-0.1875 0.82812zm0.625 1.25c0.15625 0 0.28516-0.0625 0.39062-0.1875 0.10156-0.13281 0.15625-0.29688 0.15625-0.48438s-0.054687-0.33594-0.15625-0.45312c-0.10547-0.125-0.24219-0.1875-0.40625-0.1875-0.15625 0-0.29297 0.058594-0.40625 0.17188-0.10547 0.11719-0.15625 0.26562-0.15625 0.45312s0.050781 0.35156 0.15625 0.48438c0.11328 0.13672 0.25391 0.20312 0.42188 0.20312z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1108 -448.82)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("use", {
    x: 1107.92,
    y: 452.41299,
    xlinkHref: "#glyph-9-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.146,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1112.6,
    y: 452.41299,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.27,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1118.4679,
    y: 452.41299,
    xlinkHref: "#glyph-9-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1121.1399,
    y: 452.41299,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1124.0359,
    y: 452.41299,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.1519,
    y: 452.41299,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1130.3488,
    y: 452.41299,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.8008,
    y: 452.41299,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1135.2528,
    y: 452.41299,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1137.7029,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1140.1569,
    y: 452.41299,
    xlinkHref: "#glyph-9-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1142.8269,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.2809,
    y: 452.41299,
    xlinkHref: "#glyph-9-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1146.9199,
    y: 452.41299,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1149.3719,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1150.266,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.72,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1154.3571,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1156.811,
    y: 452.41299,
    xlinkHref: "#glyph-9-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1159.2631,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1160.9023,
    y: 452.41299,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1163.5743,
    y: 452.41299,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1164.4703,
    y: 452.41299,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1166.9225,
    y: 452.41299,
    xlinkHref: "#glyph-9-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1169.5945,
    y: 452.41299,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.8204,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1174.2744,
    y: 452.41299,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1176.9464,
    y: 452.41299,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1177.8424,
    y: 452.41299,
    xlinkHref: "#glyph-9-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1180.7384,
    y: 452.41299,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1183.4104,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1185.0497,
    y: 452.41299,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1187.5016,
    y: 452.41299,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.1736,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1191.8129,
    y: 452.41299,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1192.7089,
    y: 452.41299,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1195.3809,
    y: 452.41299,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1198.0529,
    y: 452.41299,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1198.9489,
    y: 452.41299,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1201.1769,
    y: 452.41299,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1203.6289,
    y: 452.41299,
    xlinkHref: "#glyph-9-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1206.0809,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1207.7179,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.1719,
    y: 452.41299,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.8439,
    y: 452.41299,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1215.0718,
    y: 452.41299,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1217.5239,
    y: 452.41299,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1218.4199,
    y: 452.41299,
    xlinkHref: "#glyph-9-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1220.8719,
    y: 452.41299,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1223.7678,
    y: 452.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1225.405,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1228.6034,
    y: 452.41299,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1231.2754,
    y: 452.41299,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1234.1714,
    y: 452.41299,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1236.8434,
    y: 452.41299,
    xlinkHref: "#glyph-9-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1239.5155,
    y: 452.41299,
    xlinkHref: "#glyph-9-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1242.1855,
    y: 452.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.92,
    y: 457.41299,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.624,
    y: 457.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1111.5497,
    y: 457.41299,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1112.4777,
    y: 457.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.4036,
    y: 457.41299,
    xlinkHref: "#glyph-9-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.6609,
    y: 457.41299,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1117.9384,
    y: 457.41299,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1120.4243,
    y: 457.41299,
    xlinkHref: "#glyph-9-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1121.5723,
    y: 457.41299,
    xlinkHref: "#glyph-9-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1123.6123,
    y: 457.41299,
    xlinkHref: "#glyph-9-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1125.6522,
    y: 457.41299,
    xlinkHref: "#glyph-9-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.6923,
    y: 457.41299,
    xlinkHref: "#glyph-9-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.7322,
    y: 457.41299,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1131.7722,
    y: 457.41299,
    xlinkHref: "#glyph-9-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1133.8123,
    y: 457.41299,
    xlinkHref: "#glyph-9-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1135.8522,
    y: 457.41299,
    xlinkHref: "#glyph-9-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.2317,
    y: 457.66885,
    xlinkHref: "#glyph-9-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1141.2899,
    y: 457.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1143.7759,
    y: 457.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1146.2599,
    y: 457.66885,
    xlinkHref: "#glyph-9-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1148.9639,
    y: 457.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1149.8895,
    y: 457.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.8157,
    y: 457.66885,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1156.8721,
    y: 457.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1158.9121,
    y: 457.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1161.838,
    y: 457.66885,
    xlinkHref: "#glyph-9-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1164.766,
    y: 457.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1165.6919,
    y: 457.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1168.1759,
    y: 457.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1170.4333,
    y: 457.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.3595,
    y: 457.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1174.0635,
    y: 457.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1177.899,
    y: 457.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1179.939,
    y: 457.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1181.979,
    y: 457.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1186.0354,
    y: 457.66885,
    xlinkHref: "#glyph-9-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1188.2915,
    y: 457.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.7775,
    y: 457.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1193.4796,
    y: 457.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1197.3163,
    y: 457.66885,
    xlinkHref: "#glyph-9-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1200.0203,
    y: 457.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1202.9464,
    y: 457.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1206.0944,
    y: 457.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1209.9304,
    y: 457.66885,
    xlinkHref: "#glyph-9-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.4144,
    y: 457.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1215.1165,
    y: 457.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1217.6025,
    y: 457.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1220.0865,
    y: 457.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1221.0125,
    y: 457.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1224.4044,
    y: 457.66885,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1226.4044,
    y: 457.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1228.6844,
    y: 457.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1230.7235,
    y: 457.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1233.0035,
    y: 457.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1235.0403,
    y: 457.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1237.2485,
    y: 457.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1239.9497,
    y: 457.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1243.7858,
    y: 457.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9165,
    y: 462.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.5966,
    y: 462.66885,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.2765,
    y: 462.66885,
    xlinkHref: "#glyph-10-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.7366,
    y: 462.66885,
    xlinkHref: "#glyph-10-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1117.5267,
    y: 462.66885,
    xlinkHref: "#glyph-10-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1118.4308,
    y: 462.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1120.4468,
    y: 462.66885,
    xlinkHref: "#glyph-10-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1122.4628,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1123.3668,
    y: 462.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1125.3828,
    y: 462.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.3988,
    y: 462.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.4148,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1130.3187,
    y: 462.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.3348,
    y: 462.66885,
    xlinkHref: "#glyph-10-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1134.3508,
    y: 462.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1136.3668,
    y: 462.66885,
    xlinkHref: "#glyph-10-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1137.2708,
    y: 462.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.2867,
    y: 462.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1141.3027,
    y: 462.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1143.3187,
    y: 462.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.3348,
    y: 462.66885,
    xlinkHref: "#glyph-10-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1146.4587,
    y: 462.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1148.4747,
    y: 462.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1151.2277,
    y: 462.66885,
    xlinkHref: "#glyph-10-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1154.3517,
    y: 462.66885,
    xlinkHref: "#glyph-10-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1157.2557,
    y: 462.66885,
    xlinkHref: "#glyph-10-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1159.9357,
    y: 462.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1163.1332,
    y: 462.66885,
    xlinkHref: "#glyph-10-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1165.8132,
    y: 462.66885,
    xlinkHref: "#glyph-10-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1168.7172,
    y: 462.66885,
    xlinkHref: "#glyph-10-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.8412,
    y: 462.66885,
    xlinkHref: "#glyph-10-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1175.0387,
    y: 462.66885,
    xlinkHref: "#glyph-10-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1177.4987,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1178.4027,
    y: 462.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1180.8606,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1181.7626,
    y: 462.66885,
    xlinkHref: "#glyph-10-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1184.2225,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1185.8634,
    y: 462.66885,
    xlinkHref: "#glyph-10-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1188.3234,
    y: 462.66885,
    xlinkHref: "#glyph-10-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1189.2274,
    y: 462.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1192.6447,
    y: 462.66885,
    xlinkHref: "#glyph-10-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1194.6606,
    y: 462.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1196.6766,
    y: 462.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1198.6927,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1199.5967,
    y: 462.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1201.6127,
    y: 462.66885,
    xlinkHref: "#glyph-10-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1203.6287,
    y: 462.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1205.6447,
    y: 462.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1206.5487,
    y: 462.66885,
    xlinkHref: "#glyph-10-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1208.5647,
    y: 462.66885,
    xlinkHref: "#glyph-10-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.5807,
    y: 462.66885,
    xlinkHref: "#glyph-10-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.5967,
    y: 462.66885,
    xlinkHref: "#glyph-10-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1216.3867,
    y: 462.66885,
    xlinkHref: "#glyph-10-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1220.1787,
    y: 462.66885,
    xlinkHref: "#glyph-10-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1223.9707,
    y: 462.66885,
    xlinkHref: "#glyph-10-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1224.8748,
    y: 462.66885,
    xlinkHref: "#glyph-10-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1227.1107,
    y: 462.66885,
    xlinkHref: "#glyph-10-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1229.5708,
    y: 462.66885,
    xlinkHref: "#glyph-10-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1233.3606,
    y: 462.66885,
    xlinkHref: "#glyph-10-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1237.1526,
    y: 462.66885,
    xlinkHref: "#glyph-10-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1240.9446,
    y: 462.66885,
    xlinkHref: "#glyph-10-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9165,
    y: 467.66885,
    xlinkHref: "#glyph-10-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1109.0486,
    y: 467.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1111.0725,
    y: 467.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.0966,
    y: 467.66885,
    xlinkHref: "#glyph-10-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.1205,
    y: 467.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1117.1445,
    y: 467.66885,
    xlinkHref: "#glyph-10-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1118.2765,
    y: 467.66885,
    xlinkHref: "#glyph-10-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1120.3005,
    y: 467.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1122.3246,
    y: 467.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1124.3485,
    y: 467.66885,
    xlinkHref: "#glyph-10-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1125.4806,
    y: 467.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.5045,
    y: 467.66885,
    xlinkHref: "#glyph-10-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.5286,
    y: 467.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1131.5525,
    y: 467.66885,
    xlinkHref: "#glyph-10-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.6846,
    y: 467.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1133.5966,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1134.6958,
    y: 467.66885,
    xlinkHref: "#glyph-10-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1136.7198,
    y: 467.66885,
    xlinkHref: "#glyph-10-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.4078,
    y: 467.66885,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1142.0958,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1143.1954,
    y: 467.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.2195,
    y: 467.66885,
    xlinkHref: "#glyph-10-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1147.2434,
    y: 467.66885,
    xlinkHref: "#glyph-10-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1149.2675,
    y: 467.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1151.2914,
    y: 467.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1153.3154,
    y: 467.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1155.3395,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1156.4391,
    y: 467.66885,
    xlinkHref: "#glyph-10-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1158.683,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1161.151,
    y: 467.66885,
    xlinkHref: "#glyph-10-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1163.839,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1166.307,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1167.4066,
    y: 467.66885,
    xlinkHref: "#glyph-10-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1170.0946,
    y: 467.66885,
    xlinkHref: "#glyph-10-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.0066,
    y: 467.66885,
    xlinkHref: "#glyph-10-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1176.1387,
    y: 467.66885,
    xlinkHref: "#glyph-10-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1178.6067,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1179.7054,
    y: 467.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1182.3934,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1184.8615,
    y: 467.66885,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1187.5494,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.0175,
    y: 467.66885,
    xlinkHref: "#glyph-10-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1192.7054,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1195.1735,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1196.2732,
    y: 467.66885,
    xlinkHref: "#glyph-10-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1197.1852,
    y: 467.66885,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1199.8732,
    y: 467.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1202.5612,
    y: 467.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1203.4731,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1204.5728,
    y: 467.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1207.2607,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1209.7288,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.8282,
    y: 467.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.8523,
    y: 467.66885,
    xlinkHref: "#glyph-10-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1214.8762,
    y: 467.66885,
    xlinkHref: "#glyph-10-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1216.9003,
    y: 467.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1218.9242,
    y: 467.66885,
    xlinkHref: "#glyph-10-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1220.9482,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1223.1472,
    y: 467.66885,
    xlinkHref: "#glyph-10-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1226.2793,
    y: 467.66885,
    xlinkHref: "#glyph-10-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1229.1913,
    y: 467.66885,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1231.8793,
    y: 467.66885,
    xlinkHref: "#glyph-10-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1234.1233,
    y: 467.66885,
    xlinkHref: "#glyph-10-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1236.8113,
    y: 467.66885,
    xlinkHref: "#glyph-10-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1239.2793,
    y: 467.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1241.7472,
    y: 467.66885,
    xlinkHref: "#glyph-10-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1243.7712,
    y: 467.66885,
    xlinkHref: "#glyph-10-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1244.6832,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9165,
    y: 472.66885,
    xlinkHref: "#glyph-10-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.8165,
    y: 472.66885,
    xlinkHref: "#glyph-10-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.4926,
    y: 472.66885,
    xlinkHref: "#glyph-10-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.9485,
    y: 472.66885,
    xlinkHref: "#glyph-10-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1118.4045,
    y: 472.66885,
    xlinkHref: "#glyph-10-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1120.8606,
    y: 472.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1123.5365,
    y: 472.66885,
    xlinkHref: "#glyph-10-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1125.1772,
    y: 472.66885,
    xlinkHref: "#glyph-10-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.8533,
    y: 472.66885,
    xlinkHref: "#glyph-10-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.8652,
    y: 472.66885,
    xlinkHref: "#glyph-10-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1133.0625,
    y: 472.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1135.0745,
    y: 472.66885,
    xlinkHref: "#glyph-10-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1137.9745,
    y: 472.66885,
    xlinkHref: "#glyph-10-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1140.7273,
    y: 472.66885,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1143.4033,
    y: 472.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.8593,
    y: 472.66885,
    xlinkHref: "#glyph-10-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1148.3153,
    y: 472.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1151.5126,
    y: 472.66885,
    xlinkHref: "#glyph-10-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1154.7091,
    y: 472.66885,
    xlinkHref: "#glyph-10-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1157.8291,
    y: 472.66885,
    xlinkHref: "#glyph-10-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1160.7291,
    y: 472.66885,
    xlinkHref: "#glyph-10-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1163.4052,
    y: 472.66885,
    xlinkHref: "#glyph-10-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1165.8611,
    y: 472.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1167.501,
    y: 472.66885,
    xlinkHref: "#glyph-10-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.2889,
    y: 472.66885,
    xlinkHref: "#glyph-10-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1175.077,
    y: 472.66885,
    xlinkHref: "#glyph-10-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1178.865,
    y: 472.66885,
    xlinkHref: "#glyph-10-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1182.653,
    y: 472.66885,
    xlinkHref: "#glyph-10-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1186.4409,
    y: 472.66885,
    xlinkHref: "#glyph-10-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.229,
    y: 472.66885,
    xlinkHref: "#glyph-10-54"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1194.017,
    y: 472.66885,
    xlinkHref: "#glyph-10-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1198.5464,
    y: 472.66885,
    xlinkHref: "#glyph-10-55"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1202.3344,
    y: 472.66885,
    xlinkHref: "#glyph-10-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1206.1224,
    y: 472.66885,
    xlinkHref: "#glyph-10-57"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.6519,
    y: 472.66885,
    xlinkHref: "#glyph-10-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1214.4399,
    y: 472.66885,
    xlinkHref: "#glyph-10-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1218.2279,
    y: 472.66885,
    xlinkHref: "#glyph-10-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1222.7566,
    y: 472.66885,
    xlinkHref: "#glyph-10-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1226.5446,
    y: 472.66885,
    xlinkHref: "#glyph-10-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1230.3326,
    y: 472.66885,
    xlinkHref: "#glyph-10-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1234.1206,
    y: 472.66885,
    xlinkHref: "#glyph-10-64"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1238.65,
    y: 472.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1240.662,
    y: 472.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1242.6741,
    y: 472.66885,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9165,
    y: 477.66885,
    xlinkHref: "#glyph-10-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1111.6666,
    y: 477.66885,
    xlinkHref: "#glyph-10-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.4166,
    y: 477.66885,
    xlinkHref: "#glyph-10-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1119.1686,
    y: 477.66885,
    xlinkHref: "#glyph-10-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1122.9187,
    y: 477.66885,
    xlinkHref: "#glyph-10-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1126.6687,
    y: 477.66885,
    xlinkHref: "#glyph-10-69"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1131.1985,
    y: 477.66885,
    xlinkHref: "#glyph-10-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1133.1744,
    y: 477.66885,
    xlinkHref: "#glyph-10-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1135.1505,
    y: 477.66885,
    xlinkHref: "#glyph-10-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.6803,
    y: 477.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1141.6562,
    y: 477.66885,
    xlinkHref: "#glyph-10-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1143.6323,
    y: 477.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.6083,
    y: 477.66885,
    xlinkHref: "#glyph-10-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1146.6923,
    y: 477.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1148.6682,
    y: 477.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1150.6443,
    y: 477.66885,
    xlinkHref: "#glyph-10-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.6202,
    y: 477.66885,
    xlinkHref: "#glyph-10-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1153.7023,
    y: 477.66885,
    xlinkHref: "#glyph-10-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1155.6783,
    y: 477.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1157.6543,
    y: 477.66885,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1159.6304,
    y: 477.66885,
    xlinkHref: "#glyph-10-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1161.6063,
    y: 477.66885,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1163.2302,
    y: 477.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1165.8702,
    y: 477.66885,
    xlinkHref: "#glyph-9-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1168.5103,
    y: 477.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.9283,
    y: 477.66885,
    xlinkHref: "#glyph-9-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.9043,
    y: 477.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1175.8802,
    y: 477.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1177.8563,
    y: 477.66885,
    xlinkHref: "#glyph-9-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1179.8323,
    y: 477.66885,
    xlinkHref: "#glyph-9-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1181.8082,
    y: 477.66885,
    xlinkHref: "#glyph-9-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1183.7842,
    y: 477.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1185.7603,
    y: 477.66885,
    xlinkHref: "#glyph-9-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1187.7362,
    y: 477.66885,
    xlinkHref: "#glyph-9-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1188.818,
    y: 477.66885,
    xlinkHref: "#glyph-9-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1191.5719,
    y: 477.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1193.2006,
    y: 477.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1196.2826,
    y: 477.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1198.7021,
    y: 477.66885,
    xlinkHref: "#glyph-9-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1199.7841,
    y: 477.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1202.8641,
    y: 477.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1205.2841,
    y: 477.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1207.9242,
    y: 477.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.7853,
    y: 477.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1214.2017,
    y: 477.66885,
    xlinkHref: "#glyph-9-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1215.8414,
    y: 477.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1218.2592,
    y: 477.66885,
    xlinkHref: "#glyph-9-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1219.1232,
    y: 477.66885,
    xlinkHref: "#glyph-9-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1221.8755,
    y: 477.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1224.5154,
    y: 477.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1226.7087,
    y: 477.66885,
    xlinkHref: "#glyph-9-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1231.0122,
    y: 477.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1234.0942,
    y: 477.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1236.5139,
    y: 477.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1239.1539,
    y: 477.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1242.015,
    y: 477.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9204,
    y: 482.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1108.8204,
    y: 482.66885,
    xlinkHref: "#glyph-9-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1111.793,
    y: 482.66885,
    xlinkHref: "#glyph-9-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.434,
    y: 482.66885,
    xlinkHref: "#glyph-9-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.4459,
    y: 482.66885,
    xlinkHref: "#glyph-9-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1117.4579,
    y: 482.66885,
    xlinkHref: "#glyph-9-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1119.47,
    y: 482.66885,
    xlinkHref: "#glyph-9-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1121.4819,
    y: 482.66885,
    xlinkHref: "#glyph-9-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1123.4938,
    y: 482.66885,
    xlinkHref: "#glyph-9-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1125.5057,
    y: 482.66885,
    xlinkHref: "#glyph-9-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.5178,
    y: 482.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1128.4177,
    y: 482.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.3177,
    y: 482.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.4377,
    y: 482.66885,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1134.8937,
    y: 482.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1137.7937,
    y: 482.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1140.4698,
    y: 482.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1142.6997,
    y: 482.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.1578,
    y: 482.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1147.8337,
    y: 482.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1151.4744,
    y: 482.66885,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1153.9303,
    y: 482.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1156.8303,
    y: 482.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1160.2485,
    y: 482.66885,
    xlinkHref: "#glyph-9-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1162.4786,
    y: 482.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1164.9365,
    y: 482.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1167.6106,
    y: 482.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1170.8103,
    y: 482.66885,
    xlinkHref: "#glyph-9-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.4862,
    y: 482.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1176.3862,
    y: 482.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1179.5062,
    y: 482.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1182.7036,
    y: 482.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1185.8236,
    y: 482.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1188.2795,
    y: 482.66885,
    xlinkHref: "#glyph-9-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.7356,
    y: 482.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1191.6356,
    y: 482.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1194.3116,
    y: 482.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1197.2115,
    y: 482.66885,
    xlinkHref: "#glyph-9-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1198.8524,
    y: 482.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1201.3083,
    y: 482.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1202.2064,
    y: 482.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1204.6644,
    y: 482.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1206.3047,
    y: 482.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1208.9814,
    y: 482.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.1788,
    y: 482.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1214.8549,
    y: 482.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1215.7549,
    y: 482.66885,
    xlinkHref: "#glyph-9-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1218.2109,
    y: 482.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1219.111,
    y: 482.66885,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1221.5669,
    y: 482.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1224.4669,
    y: 482.66885,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1227.1429,
    y: 482.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1228.0428,
    y: 482.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1230.499,
    y: 482.66885,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1233.1749,
    y: 482.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1235.407,
    y: 482.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1238.6042,
    y: 482.66885,
    xlinkHref: "#glyph-9-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1240.6163,
    y: 482.66885,
    xlinkHref: "#glyph-9-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1242.6283,
    y: 482.66885,
    xlinkHref: "#glyph-9-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9204,
    y: 487.66885,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.5565,
    y: 487.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.4164,
    y: 487.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1115.0555,
    y: 487.66885,
    xlinkHref: "#glyph-9-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1117.0275,
    y: 487.66885,
    xlinkHref: "#glyph-9-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1118.9994,
    y: 487.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1121.752,
    y: 487.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1124.3879,
    y: 487.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1127.2479,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.2198,
    y: 487.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.0798,
    y: 487.66885,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1134.7158,
    y: 487.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1135.5739,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1138.7715,
    y: 487.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.6315,
    y: 487.66885,
    xlinkHref: "#glyph-9-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1142.2675,
    y: 487.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1144.9034,
    y: 487.66885,
    xlinkHref: "#glyph-9-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1147.5394,
    y: 487.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1149.9556,
    y: 487.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.1475,
    y: 487.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1154.7836,
    y: 487.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1155.6415,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1158.0596,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1160.8118,
    y: 487.66885,
    xlinkHref: "#glyph-9-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1163.2258,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1165.6438,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1167.6158,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1169.5878,
    y: 487.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1172.0038,
    y: 487.66885,
    xlinkHref: "#glyph-9-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.7517,
    y: 487.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1177.3904,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1179.8083,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1181.7803,
    y: 487.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1184.4143,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1186.8323,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1188.8043,
    y: 487.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1191.4403,
    y: 487.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1192.2983,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1195.4951,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1197.9131,
    y: 487.66885,
    xlinkHref: "#glyph-9-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1200.1051,
    y: 487.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1202.739,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1205.157,
    y: 487.66885,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1207.5731,
    y: 487.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.433,
    y: 487.66885,
    xlinkHref: "#glyph-9-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.6244,
    y: 487.66885,
    xlinkHref: "#glyph-9-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1214.8146,
    y: 487.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1217.2324,
    y: 487.66885,
    xlinkHref: "#glyph-9-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1219.2045,
    y: 487.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1221.8405,
    y: 487.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1224.7004,
    y: 487.66885,
    xlinkHref: "#glyph-9-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1226.3398,
    y: 487.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1228.9758,
    y: 487.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1229.8358,
    y: 487.66885,
    xlinkHref: "#glyph-9-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1232.2518,
    y: 487.66885,
    xlinkHref: "#glyph-9-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1233.8906,
    y: 487.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1235.8627,
    y: 487.66885,
    xlinkHref: "#glyph-9-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1237.8346,
    y: 487.66885,
    xlinkHref: "#glyph-9-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1239.8066,
    y: 487.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1241.7786,
    y: 487.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1243.7505,
    y: 487.66885,
    xlinkHref: "#glyph-9-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1107.9204,
    y: 492.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.6084,
    y: 492.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1111.5204,
    y: 492.66885,
    xlinkHref: "#glyph-9-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1114.2085,
    y: 492.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1116.8945,
    y: 492.66885,
    xlinkHref: "#glyph-9-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1119.3645,
    y: 492.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1122.9645,
    y: 492.66885,
    xlinkHref: "#glyph-9-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1125.6526,
    y: 492.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1129.0326,
    y: 492.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.1646,
    y: 492.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1134.6326,
    y: 492.66885,
    xlinkHref: "#glyph-9-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1137.1006,
    y: 492.66885,
    xlinkHref: "#glyph-9-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1138.0126,
    y: 492.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1140.7006,
    y: 492.66885,
    xlinkHref: "#glyph-9-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1143.6125,
    y: 492.66885,
    xlinkHref: "#glyph-9-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1145.4365,
    y: 492.66885,
    xlinkHref: "#glyph-9-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1148.1245,
    y: 492.66885,
    xlinkHref: "#glyph-9-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1150.3685,
    y: 492.66885,
    xlinkHref: "#glyph-9-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1153.0565,
    y: 492.66885,
    xlinkHref: "#glyph-9-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1153.9685,
    y: 492.66885,
    xlinkHref: "#glyph-9-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1156.2124,
    y: 492.66885,
    xlinkHref: "#glyph-9-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1158.9004,
    y: 492.66885,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1162.0325,
    y: 492.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1164.0564,
    y: 492.66885,
    xlinkHref: "#glyph-9-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1166.0803,
    y: 492.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1168.1044,
    y: 492.66885,
    xlinkHref: "#glyph-9-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1170.1283,
    y: 492.66885,
    xlinkHref: "#glyph-9-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1172.1523,
    y: 492.66885,
    xlinkHref: "#glyph-9-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1174.1763,
    y: 492.66885,
    xlinkHref: "#glyph-9-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1176.6443,
    y: 492.66885,
    xlinkHref: "#glyph-9-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1179.1123,
    y: 492.66885,
    xlinkHref: "#glyph-9-25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG704);
export default __webpack_public_path__ + "static/media/g704.54f3b7730c2c1f0b6e81990402e30b6d.svg";
export { ForwardRef as ReactComponent };